// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type ServerSentEventsResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AddDataTableChartToViewData,
  AddDataTableChartToViewResponses,
  AddPatentDraftReferencePatentFileData,
  AddPatentDraftReferencePatentFileResponses,
  AppendDataTableRowsData,
  AppendDataTableRowsResponses,
  ArchivePatentDraftsData,
  ArchivePatentDraftsResponses,
  BatchDeletePatentDraftFilesData,
  BatchDeletePatentDraftFilesResponses,
  BulkRerunObjectionAnalysisData,
  BulkRerunObjectionAnalysisResponses,
  CalibrateSigmaSearchData,
  CalibrateSigmaSearchResponses,
  CancelNoveltyAnalysisData,
  CancelNoveltyAnalysisResponses,
  CaptureSuggestionReviewsData,
  CaptureSuggestionReviewsResponses,
  ChartsGetImageUrlData,
  ChartsGetImageUrlResponses,
  ChartsUpdateImageData,
  ChartsUpdateImageResponses,
  ChatAckData,
  ChatAckResponses,
  ChatCancelActiveData,
  ChatCancelActiveResponses,
  ChatCheckActiveData,
  ChatCheckActiveResponses,
  ChatClearData,
  ChatClearResponses,
  ChatCreateData,
  ChatCreateResponse,
  ChatCreateResponses,
  ChatExportData,
  ChatExportResponses,
  ChatListData,
  ChatListResponses,
  ComposePromptPreviewData,
  ComposePromptPreviewResponses,
  CompoundsAcceptSuggestionsData,
  CompoundsAcceptSuggestionsResponses,
  CompoundsAddBatchData,
  CompoundsAddBatchResponses,
  CompoundsAddData,
  CompoundsAddResponses,
  CompoundsAddV2Data,
  CompoundsAddV2Responses,
  CompoundsAlignRotationData,
  CompoundsAlignRotationResponses,
  CompoundsConvertChemdrawData,
  CompoundsConvertChemdrawResponses,
  CompoundsDeleteAllData,
  CompoundsDeleteAllResponses,
  CompoundsDeleteBatchData,
  CompoundsDeleteBatchResponses,
  CompoundsExportChemistryData,
  CompoundsExportChemistryResponses,
  CompoundsExtractFromDocxData,
  CompoundsExtractFromDocxResponses,
  CompoundsExtractSpreadsheetData,
  CompoundsExtractSpreadsheetResponses,
  CompoundsGetData,
  CompoundsGetResponses,
  CompoundsListData,
  CompoundsListResponses,
  CompoundsRenderData,
  CompoundsRenderResponses,
  CompoundsResolveIdentifiersData,
  CompoundsResolveIdentifiersResponses,
  CompoundsUpdateData,
  CompoundsUpdateImageData,
  CompoundsUpdateImageResponses,
  CompoundsUpdateResponses,
  CompoundsUpdateV2Data,
  CompoundsUpdateV2Responses,
  CreateAdminCustomFieldsData,
  CreateAdminCustomFieldsResponses,
  CreateDataTableChartData,
  CreateDataTableChartResponses,
  CreateDataTableData,
  CreateDataTableResponses,
  CreateExternalConnectionsData,
  CreateExternalConnectionsResponses,
  CreateExternalSourceAuthData,
  CreateExternalSourceAuthResponses,
  CreateExternalSourceData,
  CreateExternalSourceResponses,
  CreateFormData,
  CreateFormResponses,
  CreateGeneralAssistantData,
  CreateGeneralAssistantResponses,
  CreateGeneralAssistantV2Data,
  CreateGeneralAssistantV2Responses,
  CreateInventionAssistantData,
  CreateInventionAssistantResponses,
  CreateNoveltyAnalysisData,
  CreateNoveltyAnalysisResponses,
  CreatePatentDraftData,
  CreatePatentDraftFileByPatentNumberV2Data,
  CreatePatentDraftFileByPatentNumberV2Responses,
  CreatePatentDraftFileData,
  CreatePatentDraftFileResponses,
  CreatePatentDraftFromDisclosureData,
  CreatePatentDraftFromDisclosureResponses,
  CreatePatentDraftResponses,
  CreateSigmaSearchData,
  CreateSigmaSearchResponses,
  CustomFieldListData,
  CustomFieldListResponses,
  CustomFieldUpdateData,
  CustomFieldUpdateResponses,
  DeclineSuggestionData,
  DeclineSuggestionResponses,
  DeleteAdminCustomFieldData,
  DeleteAdminCustomFieldResponses,
  DeleteDataTableChartData,
  DeleteDataTableChartResponses,
  DeleteDataTableData,
  DeleteDataTableResponses,
  DeleteDeveloperPromptOverridesData,
  DeleteDeveloperPromptOverridesResponses,
  DeleteExternalConnectionData,
  DeleteExternalConnectionResponses,
  DeleteFormData,
  DeleteFormResponses,
  DeleteGeneralAssistantData,
  DeleteGeneralAssistantResponses,
  DeleteInventionAssistantData,
  DeleteInventionAssistantResponses,
  DeleteModelProviderOverrideData,
  DeleteModelProviderOverrideResponses,
  DeleteObjectionStatusData,
  DeleteObjectionStatusResponses,
  DeletePatentDraftFileData,
  DeletePatentDraftFileResponses,
  DeletePatentDraftReferencePatentFileData,
  DeletePatentDraftReferencePatentFileResponses,
  DeleteSigmaSearchData,
  DeleteSigmaSearchResponses,
  DeleteTemplateData,
  DeleteTemplateResponses,
  DeleteTrackedChangesData,
  DeleteTrackedChangesResponses,
  DetectDataTableImportTablesData,
  DetectDataTableImportTablesResponses,
  DocumentCreationReviewEventData,
  DocumentCreationReviewEventResponses,
  DocumentsCompleteDocxUploadData,
  DocumentsCompleteDocxUploadResponses,
  DocumentsCreateData,
  DocumentsCreateDocxUploadUrlData,
  DocumentsCreateDocxUploadUrlResponses,
  DocumentsCreateResponses,
  DocumentsDeleteData,
  DocumentsDeleteResponses,
  DocumentsDuplicateData,
  DocumentsDuplicateResponses,
  DocumentsGetByResourceIdData,
  DocumentsGetByResourceIdResponses,
  DocumentsGetData,
  DocumentsGetDocxData,
  DocumentsGetDocxResponses,
  DocumentsGetResponses,
  DocumentsPutContentData,
  DocumentsPutContentResponses,
  DocumentsPutDocxData,
  DocumentsPutDocxResponses,
  DocumentsUpdateMetadataData,
  DocumentsUpdateMetadataResponses,
  ExportDataTableData,
  ExportDataTableResponses,
  ExportDraftData,
  ExportDraftResponses,
  ExportExternalSourceItemsData,
  ExportExternalSourceItemsResponses,
  ExportFormData,
  ExportFormResponses,
  ExtractCompoundsFromDocxData,
  ExtractCompoundsFromDocxResponses,
  ExtractSpreadsheetData,
  ExtractSpreadsheetResponses,
  FeaturizeNoveltyAnalysisData,
  FeaturizeNoveltyAnalysisResponses,
  FigureDiagramsReviewFigureDiagramEventData,
  FigureDiagramsReviewFigureDiagramEventResponses,
  FigureGenerationGenerateDiagramData,
  FigureGenerationGenerateDiagramFromFileData,
  FigureGenerationGenerateDiagramFromFileResponses,
  FigureGenerationGenerateDiagramFromFileV2Data,
  FigureGenerationGenerateDiagramFromFileV2Responses,
  FigureGenerationGenerateDiagramResponses,
  FigureGenerationGenerateDiagramV2Data,
  FigureGenerationGenerateDiagramV2Responses,
  FigureGenerationGenerateImageFromFigureData,
  FigureGenerationGenerateImageFromFigureResponses,
  FigureGenerationGenerateImageFromFileData,
  FigureGenerationGenerateImageFromFileResponses,
  FigureGenerationGenerateImageFromTempFileData,
  FigureGenerationGenerateImageFromTempFileResponses,
  FigureGenerationGenerateImageFromTextV2Data,
  FigureGenerationGenerateImageFromTextV2Responses,
  FiguresBatchDeleteFiguresData,
  FiguresBatchDeleteFiguresResponses,
  FiguresBatchExportFiguresToVisioData,
  FiguresBatchExportFiguresToVisioResponses,
  FiguresBatchImportFromFileData,
  FiguresBatchImportFromFileResponses,
  FiguresDeleteFigureData,
  FiguresDeleteFigureResponses,
  FiguresExportFigureToVisioData,
  FiguresExportFigureToVisioResponses,
  FiguresExportFigureToVisioV2Data,
  FiguresExportFigureToVisioV2Responses,
  FiguresGetFigureData,
  FiguresGetFigureResponses,
  FiguresGetFiguresData,
  FiguresGetFiguresResponses,
  FiguresReorderFiguresData,
  FiguresReorderFiguresResponses,
  FiguresSaveFigureData,
  FiguresSaveFigureResponses,
  FiguresUpdateFigureInfoData,
  FiguresUpdateFigureInfoResponses,
  FiguresUploadFigureData,
  FiguresUploadFigureResponses,
  FiguresUploadFiguresBatchData,
  FiguresUploadFiguresBatchResponses,
  FileDeleteData,
  FileDeleteResponses,
  FileExtractPatentFromFileData,
  FileExtractPatentFromFileResponses,
  FileExtractPdfImagesData,
  FileExtractPdfImagesResponses,
  FileFolderAddItemsData,
  FileFolderAddItemsResponses,
  FileFolderCreateData,
  FileFolderCreateResponses,
  FileFolderDeleteData,
  FileFolderDeleteResponses,
  FileFolderGetAllData,
  FileFolderGetAllResponses,
  FileFolderUpdateData,
  FileFolderUpdateResponses,
  FileGenerateSummaryData,
  FileGenerateSummaryResponses,
  FileGetData,
  FileGetFigureFileCandidatesData,
  FileGetFigureFileCandidatesResponses,
  FileGetFiguresData,
  FileGetFiguresResponses,
  FileGetHighlightsData,
  FileGetHighlightsResponses,
  FileGetResponses,
  FileGetUrlData,
  FileGetUrlResponses,
  FileGetWorkflowFilesData,
  FileGetWorkflowFilesResponses,
  FileReviewExtractedPatentFromFileData,
  FileReviewExtractedPatentFromFileResponses,
  FileUpdateData,
  FileUpdateResponses,
  FileUploadByPatentNumberV2Data,
  FileUploadByPatentNumberV2Responses,
  FileUploadContentData,
  FileUploadContentResponses,
  FileUploadData,
  FileUploadResponses,
  GenerateDraftData,
  GenerateDraftResponses,
  GenerateSigmaSearchQueryData,
  GenerateSigmaSearchQueryResponses,
  GetAdminFeatureFlagsData,
  GetAdminFeatureFlagsResponses,
  GetDataTableData,
  GetDataTablePatentFieldValuesData,
  GetDataTablePatentFieldValuesResponses,
  GetDataTableResponses,
  GetDataTableRowsByIdsData,
  GetDataTableRowsByIdsResponses,
  GetDataTableRowsData,
  GetDataTableRowsResponses,
  GetDeveloperPromptFilesData,
  GetDeveloperPromptFilesResponses,
  GetDeveloperPromptOverridesData,
  GetDeveloperPromptOverridesResponses,
  GetDeveloperRolesOverviewData,
  GetDeveloperRolesOverviewResponses,
  GetFeatureFlagOverridesData,
  GetFeatureFlagOverridesResponses,
  GetFeatureFlagsData,
  GetFeatureFlagsResponses,
  GetFormData,
  GetFormResponses,
  GetGeneralAssistantData,
  GetGeneralAssistantResponses,
  GetGeneralAssistantsData,
  GetGeneralAssistantsResponses,
  GetInventionAssistantData,
  GetInventionAssistantResponses,
  GetInventionAssistantsData,
  GetInventionAssistantsResponses,
  GetJurisdictionLanguagesData,
  GetJurisdictionLanguagesResponses,
  GetNoveltyAnalysesData,
  GetNoveltyAnalysesResponses,
  GetNoveltyAnalysisFeaturesData,
  GetNoveltyAnalysisFeaturesResponses,
  GetNoveltyAnalysisResultsData,
  GetNoveltyAnalysisResultsResponses,
  GetNoveltyAnalysisStatusData,
  GetNoveltyAnalysisStatusResponses,
  GetNoveltyFeaturesData,
  GetNoveltyFeaturesResponses,
  GetObjectionData,
  GetObjectionResponses,
  GetObjectionStatusData,
  GetObjectionStatusResponses,
  GetOrganizationSettingsData,
  GetOrganizationSettingsResponses,
  GetOverlapAnalysisData,
  GetOverlapAnalysisResponses,
  GetOverlapAnalysisStatusData,
  GetOverlapAnalysisStatusResponses,
  GetPatentDraftData,
  GetPatentDraftFilesData,
  GetPatentDraftFilesResponses,
  GetPatentDraftResponses,
  GetPatentDraftsData,
  GetPatentDraftsResponses,
  GetResolvedSettingsData,
  GetResolvedSettingsResponses,
  GetSigmaSearchData,
  GetSigmaSearchQueryData,
  GetSigmaSearchQueryResponses,
  GetSigmaSearchResponses,
  GetSigmaSearchStatusData,
  GetSigmaSearchStatusResponses,
  GetSuggestionsData,
  GetSuggestionsResponses,
  GetTemplateData,
  GetTemplateResponses,
  GlossarySearchRelatedTermsData,
  GlossarySearchRelatedTermsResponses,
  GlossarySearchTermDefinitionsData,
  GlossarySearchTermDefinitionsResponses,
  ImportDataTableData,
  ImportDataTablePreviewData,
  ImportDataTablePreviewResponses,
  ImportDataTableResponses,
  ImportExternalSourceFilesData,
  ImportExternalSourceFilesResponses,
  InitTrackedChangesData,
  InitTrackedChangesResponses,
  ItemFolderAddItemsData,
  ItemFolderAddItemsResponses,
  ItemFolderCreateData,
  ItemFolderCreateResponses,
  ItemFolderDeleteData,
  ItemFolderDeleteResponses,
  ItemFolderGetAllData,
  ItemFolderGetAllResponses,
  ItemFolderOperationsAddItemsData,
  ItemFolderOperationsAddItemsResponses,
  ItemFolderOperationsCreateData,
  ItemFolderOperationsCreateResponses,
  ItemFolderOperationsDeleteData,
  ItemFolderOperationsDeleteResponses,
  ItemFolderOperationsGetAllData,
  ItemFolderOperationsGetAllResponses,
  ItemFolderOperationsUpdateData,
  ItemFolderOperationsUpdateResponses,
  ItemFolderUpdateData,
  ItemFolderUpdateResponses,
  KnowledgeCreateData,
  KnowledgeCreateResponses,
  KnowledgeDeleteData,
  KnowledgeDeleteResponses,
  KnowledgeFolderActivateData,
  KnowledgeFolderActivateResponses,
  KnowledgeFolderAddItemsData,
  KnowledgeFolderAddItemsResponses,
  KnowledgeFolderCreateData,
  KnowledgeFolderCreateResponses,
  KnowledgeFolderDeleteData,
  KnowledgeFolderDeleteResponses,
  KnowledgeFolderGetAllData,
  KnowledgeFolderGetAllResponses,
  KnowledgeFolderRemoveItemsData,
  KnowledgeFolderRemoveItemsResponses,
  KnowledgeFolderUpdateData,
  KnowledgeFolderUpdateResponses,
  KnowledgeGenerateDescriptionData,
  KnowledgeGenerateDescriptionResponses,
  KnowledgeGetData,
  KnowledgeGetEventData,
  KnowledgeGetEventResponses,
  KnowledgeGetResponses,
  KnowledgeListData,
  KnowledgeListResponses,
  KnowledgeReviewEventData,
  KnowledgeReviewEventResponses,
  KnowledgeSetActiveData,
  KnowledgeSetActiveResponses,
  KnowledgeSetAutoLoadData,
  KnowledgeSetAutoLoadResponses,
  KnowledgeUpdateData,
  KnowledgeUpdateResponses,
  ListAdminCustomFieldsData,
  ListAdminCustomFieldsResponses,
  ListDataTableChartsData,
  ListDataTableChartsResponses,
  ListDataTablesData,
  ListDataTablesResponses,
  ListExternalConnectionsData,
  ListExternalConnectionsResponses,
  ListExternalSourceConfigsData,
  ListExternalSourceConfigsResponses,
  ListExternalSourceItemsData,
  ListExternalSourceItemsResponses,
  ListExternalSourcesData,
  ListExternalSourcesResponses,
  ListFormsData,
  ListFormsResponses,
  ListPatentFamilyMembersData,
  ListPatentFamilyMembersResponses,
  ListSigmaSearchesData,
  ListSigmaSearchesResponses,
  ListTasksData,
  ListTasksResponses,
  ListTemplatesData,
  ListTemplatesResponses,
  OrgProjectAnalyticsData,
  OrgProjectAnalyticsResponses,
  OrgProjectQueryAnalyticsData,
  OrgProjectQueryAnalyticsResponses,
  ParseCdxCmlData,
  ParseCdxCmlResponses,
  ParseModificationsData,
  ParseModificationsResponses,
  PatentDraftSequenceMolTypeListData,
  PatentDraftSequenceMolTypeListResponses,
  PatentDraftSequencesBatchCreateData,
  PatentDraftSequencesBatchCreateResponses,
  PatentDraftSequencesBulkRenumberData,
  PatentDraftSequencesBulkRenumberResponses,
  PatentDraftSequencesCreateData,
  PatentDraftSequencesCreateResponses,
  PatentDraftSequencesDeleteAllData,
  PatentDraftSequencesDeleteAllResponses,
  PatentDraftSequencesDeleteBatchData,
  PatentDraftSequencesDeleteBatchResponses,
  PatentDraftSequencesExportData,
  PatentDraftSequencesExportResponses,
  PatentDraftSequencesExtractFromTabularFileData,
  PatentDraftSequencesExtractFromTabularFileResponses,
  PatentDraftSequencesGetData,
  PatentDraftSequencesGetResponses,
  PatentDraftSequencesImportSequencesData,
  PatentDraftSequencesImportSequencesResponses,
  PatentDraftSequencesListData,
  PatentDraftSequencesListResponses,
  PatentDraftSequencesUpdateData,
  PatentDraftSequencesUpdateResponses,
  PatentOfficeFileImportFilesData,
  PatentOfficeFileImportFilesResponses,
  PreviewExternalSourceFileData,
  PreviewExternalSourceFileResponses,
  ProjectAnalyticsData,
  ProjectAnalyticsResponses,
  ProjectDeleteProjectsData,
  ProjectDeleteProjectsResponses,
  ProjectFacetsData,
  ProjectFacetsResponses,
  ProjectFolderAddItemsData,
  ProjectFolderAddItemsResponses,
  ProjectFolderCreateData,
  ProjectFolderCreateResponses,
  ProjectFolderDeleteData,
  ProjectFolderDeleteResponses,
  ProjectFolderGetAllData,
  ProjectFolderGetAllResponses,
  ProjectFolderGetData,
  ProjectFolderGetResponses,
  ProjectFolderQueryData,
  ProjectFolderQueryResponses,
  ProjectFolderRemoveItemsData,
  ProjectFolderRemoveItemsResponses,
  ProjectFolderUpdateData,
  ProjectFolderUpdateResponses,
  ProjectListData,
  ProjectListResponses,
  ProjectQueryAnalyticsData,
  ProjectQueryAnalyticsResponses,
  ProjectQueryData,
  ProjectQueryFacetsData,
  ProjectQueryFacetsResponses,
  ProjectQueryResponses,
  ProjectTrackProjectViewedData,
  ProjectTrackProjectViewedResponses,
  ProjectUpdateReviewData,
  ProjectUpdateReviewResponses,
  PutContentData,
  PutContentResponses,
  PutContentWithCommentsData,
  PutContentWithCommentsResponses,
  PutDeveloperPromptOverrideData,
  PutDeveloperPromptOverrideResponses,
  PutPatentDraftCustomInstructionsIdData,
  PutPatentDraftCustomInstructionsIdResponses,
  PutPatentDraftDraftingModeData,
  PutPatentDraftDraftingModeResponses,
  PutPatentDraftInventionDescriptionData,
  PutPatentDraftInventionDescriptionResponses,
  PutPatentDraftJurisdictionData,
  PutPatentDraftJurisdictionResponses,
  PutPatentDraftLanguageData,
  PutPatentDraftLanguageResponses,
  PutPatentDraftNameData,
  PutPatentDraftNameResponses,
  PutPatentDraftReferencePatentIdsData,
  PutPatentDraftReferencePatentIdsResponses,
  PutSigmaSearchQueryData,
  PutSigmaSearchQueryResponses,
  PutTemplateData,
  PutTemplateResponses,
  QueueFileForOcrData,
  QueueFileForOcrResponses,
  ReferenceSignArchiveReferenceSignsData,
  ReferenceSignArchiveReferenceSignsResponses,
  ReferenceSignBatchCreateReferenceSignsData,
  ReferenceSignBatchCreateReferenceSignsResponses,
  ReferenceSignBatchEditReferenceSignsData,
  ReferenceSignBatchEditReferenceSignsResponses,
  ReferenceSignBatchGenerateReferenceSignsData,
  ReferenceSignBatchGenerateReferenceSignsResponses,
  ReferenceSignBatchLinkReferenceSignsData,
  ReferenceSignBatchLinkReferenceSignsResponses,
  ReferenceSignBatchUnlinkReferenceSignsData,
  ReferenceSignBatchUnlinkReferenceSignsResponses,
  ReferenceSignCreateReferenceSignData,
  ReferenceSignCreateReferenceSignResponses,
  ReferenceSignEditReferenceSignData,
  ReferenceSignEditReferenceSignResponses,
  ReferenceSignGenerateReferenceSignsForFigureData,
  ReferenceSignGenerateReferenceSignsForFigureResponses,
  ReferenceSignGenerateReferenceSignsFromImageData,
  ReferenceSignGenerateReferenceSignsFromImageResponses,
  ReferenceSignGetReferenceSignsByFigureData,
  ReferenceSignGetReferenceSignsByFigureResponses,
  ReferenceSignGetReferenceSignsByResourceData,
  ReferenceSignGetReferenceSignsByResourceResponses,
  ReferenceSignImportReferenceSignsFromDocumentData,
  ReferenceSignImportReferenceSignsFromDocumentResponses,
  ReferenceSignLinkReferenceSignData,
  ReferenceSignLinkReferenceSignResponses,
  ReferenceSignPlaceReferenceSignsData,
  ReferenceSignPlaceReferenceSignsResponses,
  ReferenceSignPlaceReferenceSignsV2Data,
  ReferenceSignPlaceReferenceSignsV2Responses,
  ReferenceSignPutValueData,
  ReferenceSignPutValueResponses,
  ReferenceSignUnlinkReferenceSignData,
  ReferenceSignUnlinkReferenceSignResponses,
  RerunObjectionAnalysisData,
  RerunObjectionAnalysisResponses,
  ResourceAccessEffectiveAccessData,
  ResourceAccessEffectiveAccessResponses,
  ResourceAccessUpdateResourceAccessData,
  ResourceAccessUpdateResourceAccessResponses,
  ResourceKnowledgeAttachData,
  ResourceKnowledgeAttachResponses,
  ResourceKnowledgeAttachToDocumentData,
  ResourceKnowledgeAttachToDocumentResponses,
  ResourceKnowledgeDetachData,
  ResourceKnowledgeDetachFromDocumentData,
  ResourceKnowledgeDetachFromDocumentResponses,
  ResourceKnowledgeDetachResponses,
  ResourceKnowledgeListData,
  ResourceKnowledgeListForDocumentData,
  ResourceKnowledgeListForDocumentResponses,
  ResourceKnowledgeListResponses,
  ResourceKnowledgeResolveTemplateShareConflictsData,
  ResourceKnowledgeResolveTemplateShareConflictsResponses,
  ResourceKnowledgeTemplateShareConflictsData,
  ResourceKnowledgeTemplateShareConflictsResponses,
  ReviewDataTableCellsData,
  ReviewDataTableCellsResponses,
  ReviewDataTableChartData,
  ReviewDataTableChartResponses,
  ReviewSearchSuggestionData,
  ReviewSearchSuggestionResponses,
  ReviewSuggestionData,
  ReviewSuggestionResponses,
  RunSigmaSearchData,
  RunSigmaSearchResponses,
  SaveFormAnswersData,
  SaveFormAnswersResponses,
  SaveFormTemplateData,
  SaveFormTemplateResponses,
  SaveFromChatDataTableData,
  SaveFromChatDataTableResponses,
  SaveTableTemplateData,
  SaveTableTemplateResponses,
  SearchExternalSourceItemsData,
  SearchExternalSourceItemsResponses,
  SequenceMolTypesListData,
  SequenceMolTypesListResponses,
  SequencesBatchCreateData,
  SequencesBatchCreateResponses,
  SequencesBulkRenumberData,
  SequencesBulkRenumberResponses,
  SequencesDeleteAllData,
  SequencesDeleteAllResponses,
  SequencesDeleteBatchData,
  SequencesDeleteBatchResponses,
  SequencesExportData,
  SequencesExportResponses,
  SequencesExtractFromTabularFileData,
  SequencesExtractFromTabularFileResponses,
  SequencesGetData,
  SequencesGetResponses,
  SequencesImportSequencesData,
  SequencesImportSequencesResponses,
  SequencesListData,
  SequencesListResponses,
  SequencesParseModificationsData,
  SequencesParseModificationsResponses,
  SequencesUpdateData,
  SequencesUpdateResponses,
  SetExternalSourceCredentialsData,
  SetExternalSourceCredentialsResponses,
  SetModelProviderOverrideData,
  SetModelProviderOverrideResponses,
  SetupOfficeActionData,
  SetupOfficeActionResponses,
  TemporaryFileGetTemporaryFileData,
  TemporaryFileGetTemporaryFileResponses,
  TemporaryFileUploadTemporaryFileData,
  TemporaryFileUploadTemporaryFileResponses,
  UpdateAdminCustomFieldData,
  UpdateAdminCustomFieldResponses,
  UpdateDataTableChartData,
  UpdateDataTableChartResponses,
  UpdateDataTableChartViewData,
  UpdateDataTableChartViewResponses,
  UpdateDataTableData,
  UpdateDataTableResponses,
  UpdateExternalSourceData,
  UpdateExternalSourceResponses,
  UpdateGeneralAssistantData,
  UpdateGeneralAssistantResponses,
  UpdateInventionAssistantData,
  UpdateInventionAssistantResponses,
  UpdateNoveltyAnalysisData,
  UpdateNoveltyAnalysisResponses,
  UpdateNoveltyFeaturesData,
  UpdateNoveltyFeaturesResponses,
  UpdateObjectionStatusData,
  UpdateObjectionStatusResponses,
  UpdateOrganizationSettingsData,
  UpdateOrganizationSettingsResponses,
  UpdateOrgFeatureFlagOverrideData,
  UpdateOrgFeatureFlagOverrideResponses,
  UpdatePatentDraftFileInfoData,
  UpdatePatentDraftFileInfoResponses,
  UpdateSigmaSearchData,
  UpdateSigmaSearchResponses,
  UpdateTemplateData,
  UpdateTemplateResponses,
  UpdateUserFeatureFlagOverrideData,
  UpdateUserFeatureFlagOverrideResponses,
  UserLookupData,
  UserLookupResponses,
  ViewDataTableChartsData,
  ViewDataTableChartsResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const resourceAccessUpdateResourceAccess = <ThrowOnError extends boolean = false>(
  options: Options<ResourceAccessUpdateResourceAccessData, ThrowOnError>,
): RequestResult<ResourceAccessUpdateResourceAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ResourceAccessUpdateResourceAccessResponses, unknown, ThrowOnError>({
    url: '/access',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resourceAccessEffectiveAccess = <ThrowOnError extends boolean = false>(
  options: Options<ResourceAccessEffectiveAccessData, ThrowOnError>,
): RequestResult<ResourceAccessEffectiveAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ResourceAccessEffectiveAccessResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/access/{resourceType}/{resourceId}/effective',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getAdminFeatureFlags = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminFeatureFlagsData, ThrowOnError>,
): RequestResult<GetAdminFeatureFlagsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetAdminFeatureFlagsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { 'flag-key': { array: { explode: false } } } },
    responseType: 'json',
    url: '/admin/feature-flag',
    ...options,
  });

export const updateUserFeatureFlagOverride = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserFeatureFlagOverrideData, ThrowOnError>,
): RequestResult<UpdateUserFeatureFlagOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdateUserFeatureFlagOverrideResponses, unknown, ThrowOnError>({
    url: '/admin/feature-flag/user/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getFeatureFlagOverrides = <ThrowOnError extends boolean = false>(
  options: Options<GetFeatureFlagOverridesData, ThrowOnError>,
): RequestResult<GetFeatureFlagOverridesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetFeatureFlagOverridesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/admin/feature-flag/{flagKey}/overrides',
    ...options,
  });

export const updateOrgFeatureFlagOverride = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrgFeatureFlagOverrideData, ThrowOnError>,
): RequestResult<UpdateOrgFeatureFlagOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdateOrgFeatureFlagOverrideResponses, unknown, ThrowOnError>({
    url: '/admin/feature-flag/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const chartsUpdateImage = <ThrowOnError extends boolean = false>(
  options: Options<ChartsUpdateImageData, ThrowOnError>,
): RequestResult<ChartsUpdateImageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChartsUpdateImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/chart/{chartId}/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const chartsGetImageUrl = <ThrowOnError extends boolean = false>(
  options: Options<ChartsGetImageUrlData, ThrowOnError>,
): RequestResult<ChartsGetImageUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChartsGetImageUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/chart/{chartId}/image-url',
    ...options,
  });

export const chatAck = <ThrowOnError extends boolean = false>(
  options: Options<ChatAckData, ThrowOnError>,
): RequestResult<ChatAckResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ChatAckResponses, unknown, ThrowOnError>({
    url: '/chat/{messageId}/ack',
    ...options,
  });

export const chatCancelActive = <ThrowOnError extends boolean = false>(
  options: Options<ChatCancelActiveData, ThrowOnError>,
): RequestResult<ChatCancelActiveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ChatCancelActiveResponses, unknown, ThrowOnError>({
    url: '/chat/{messageId}/active',
    ...options,
  });

export const reviewSuggestion = <ThrowOnError extends boolean = false>(
  options: Options<ReviewSuggestionData, ThrowOnError>,
): RequestResult<ReviewSuggestionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReviewSuggestionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/chat/{resourceType}/suggestions/{suggestionId}/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const chatClear = <ThrowOnError extends boolean = false>(
  options: Options<ChatClearData, ThrowOnError>,
): RequestResult<ChatClearResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ChatClearResponses, unknown, ThrowOnError>({
    url: '/chat/{resourceType}/{resourceId}',
    ...options,
  });

export const chatList = <ThrowOnError extends boolean = false>(
  options: Options<ChatListData, ThrowOnError>,
): RequestResult<ChatListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChatListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/chat/{resourceType}/{resourceId}',
    ...options,
  });

export const chatCreate = <ThrowOnError extends boolean = false>(
  options: Options<ChatCreateData, ThrowOnError, ChatCreateResponse>,
): Promise<ServerSentEventsResult<ChatCreateResponses>> =>
  (options.client ?? client).sse.post<ChatCreateResponses, unknown, ThrowOnError>({
    querySerializer: {
      parameters: { 'user-selected-files': { array: { explode: false } }, 'chat-mode': { array: { explode: false } } },
    },
    responseType: 'text',
    url: '/chat/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const chatCheckActive = <ThrowOnError extends boolean = false>(
  options: Options<ChatCheckActiveData, ThrowOnError>,
): RequestResult<ChatCheckActiveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChatCheckActiveResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/chat/{resourceType}/{resourceId}/active',
    ...options,
  });

export const chatExport = <ThrowOnError extends boolean = false>(
  options: Options<ChatExportData, ThrowOnError>,
): RequestResult<ChatExportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ChatExportResponses, unknown, ThrowOnError>({
    url: '/chat/{resourceType}/{resourceId}/export',
    ...options,
  });

export const compoundsAlignRotation = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsAlignRotationData, ThrowOnError>,
): RequestResult<CompoundsAlignRotationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsAlignRotationResponses, unknown, ThrowOnError>({
    url: '/compound/align-compounds-rotation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsDeleteBatch = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsDeleteBatchData, ThrowOnError>,
): RequestResult<CompoundsDeleteBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CompoundsDeleteBatchResponses, unknown, ThrowOnError>({
    url: '/compound/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsAcceptSuggestions = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsAcceptSuggestionsData, ThrowOnError>,
): RequestResult<CompoundsAcceptSuggestionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsAcceptSuggestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/batch-accept-suggestions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsExportChemistry = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsExportChemistryData, ThrowOnError>,
): RequestResult<CompoundsExportChemistryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsExportChemistryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/export-chemistry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsRender = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsRenderData, ThrowOnError>,
): RequestResult<CompoundsRenderResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsRenderResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/render',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsResolveIdentifiers = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsResolveIdentifiersData, ThrowOnError>,
): RequestResult<CompoundsResolveIdentifiersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsResolveIdentifiersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/resolve-identifiers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsUpdateV2 = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsUpdateV2Data, ThrowOnError>,
): RequestResult<CompoundsUpdateV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CompoundsUpdateV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/v2/{compoundId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsAddV2 = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsAddV2Data, ThrowOnError>,
): RequestResult<CompoundsAddV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsAddV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/v2/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsGet = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsGetData, ThrowOnError>,
): RequestResult<CompoundsGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CompoundsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/{compoundId}',
    ...options,
  });

export const compoundsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsUpdateData, ThrowOnError>,
): RequestResult<CompoundsUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CompoundsUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/{compoundId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsUpdateImage = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsUpdateImageData, ThrowOnError>,
): RequestResult<CompoundsUpdateImageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsUpdateImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/compound/{compoundId}/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const compoundsList = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsListData, ThrowOnError>,
): RequestResult<CompoundsListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CompoundsListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}',
    ...options,
  });

/**
 * @deprecated
 */
export const compoundsAdd = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsAddData, ThrowOnError>,
): RequestResult<CompoundsAddResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsAddResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsDeleteAll = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsDeleteAllData, ThrowOnError>,
): RequestResult<CompoundsDeleteAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CompoundsDeleteAllResponses, unknown, ThrowOnError>({
    url: '/compound/{resourceType}/{resourceId}/all',
    ...options,
  });

export const compoundsAddBatch = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsAddBatchData, ThrowOnError>,
): RequestResult<CompoundsAddBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsAddBatchResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const compoundsConvertChemdraw = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsConvertChemdrawData, ThrowOnError>,
): RequestResult<CompoundsConvertChemdrawResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsConvertChemdrawResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}/convert-chemdraw',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const compoundsExtractFromDocx = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsExtractFromDocxData, ThrowOnError>,
): RequestResult<CompoundsExtractFromDocxResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsExtractFromDocxResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}/extract-docx',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const compoundsExtractSpreadsheet = <ThrowOnError extends boolean = false>(
  options: Options<CompoundsExtractSpreadsheetData, ThrowOnError>,
): RequestResult<CompoundsExtractSpreadsheetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CompoundsExtractSpreadsheetResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/compound/{resourceType}/{resourceId}/extract-spreadsheet',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const customFieldList = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldListData, ThrowOnError>,
): RequestResult<CustomFieldListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CustomFieldListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/custom-fields',
    ...options,
  });

/**
 * Sets or clears only the fields in the request; fields not listed keep their values.
 */
export const customFieldUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldUpdateData, ThrowOnError>,
): RequestResult<CustomFieldUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CustomFieldUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/custom-fields/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createDataTable = <ThrowOnError extends boolean = false>(
  options: Options<CreateDataTableData, ThrowOnError>,
): RequestResult<CreateDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateDataTableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importDataTable = <ThrowOnError extends boolean = false>(
  options: Options<ImportDataTableData, ThrowOnError>,
): RequestResult<ImportDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ImportDataTableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const detectDataTableImportTables = <ThrowOnError extends boolean = false>(
  options: Options<DetectDataTableImportTablesData, ThrowOnError>,
): RequestResult<DetectDataTableImportTablesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DetectDataTableImportTablesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/import/detect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importDataTablePreview = <ThrowOnError extends boolean = false>(
  options: Options<ImportDataTablePreviewData, ThrowOnError>,
): RequestResult<ImportDataTablePreviewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ImportDataTablePreviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/import/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const saveFromChatDataTable = <ThrowOnError extends boolean = false>(
  options: Options<SaveFromChatDataTableData, ThrowOnError>,
): RequestResult<SaveFromChatDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveFromChatDataTableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/save-from-chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listDataTables = <ThrowOnError extends boolean = false>(
  options: Options<ListDataTablesData, ThrowOnError>,
): RequestResult<ListDataTablesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListDataTablesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{resourceType}/{resourceId}',
    ...options,
  });

export const deleteDataTable = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDataTableData, ThrowOnError>,
): RequestResult<DeleteDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteDataTableResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}',
    ...options,
  });

export const getDataTable = <ThrowOnError extends boolean = false>(
  options: Options<GetDataTableData, ThrowOnError>,
): RequestResult<GetDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetDataTableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}',
    ...options,
  });

export const updateDataTable = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDataTableData, ThrowOnError>,
): RequestResult<UpdateDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateDataTableResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const listDataTableCharts = <ThrowOnError extends boolean = false>(
  options: Options<ListDataTableChartsData, ThrowOnError>,
): RequestResult<ListDataTableChartsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListDataTableChartsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/charts',
    ...options,
  });

export const createDataTableChart = <ThrowOnError extends boolean = false>(
  options: Options<CreateDataTableChartData, ThrowOnError>,
): RequestResult<CreateDataTableChartResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateDataTableChartResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/charts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const updateDataTableChartView = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDataTableChartViewData, ThrowOnError>,
): RequestResult<UpdateDataTableChartViewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateDataTableChartViewResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/charts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const viewDataTableCharts = <ThrowOnError extends boolean = false>(
  options: Options<ViewDataTableChartsData, ThrowOnError>,
): RequestResult<ViewDataTableChartsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ViewDataTableChartsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/charts/view',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteDataTableChart = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDataTableChartData, ThrowOnError>,
): RequestResult<DeleteDataTableChartResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteDataTableChartResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/charts/{chartId}',
    ...options,
  });

export const updateDataTableChart = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDataTableChartData, ThrowOnError>,
): RequestResult<UpdateDataTableChartResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateDataTableChartResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/charts/{chartId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const addDataTableChartToView = <ThrowOnError extends boolean = false>(
  options: Options<AddDataTableChartToViewData, ThrowOnError>,
): RequestResult<AddDataTableChartToViewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AddDataTableChartToViewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/charts/{chartId}/add',
    ...options,
  });

export const reviewDataTableChart = <ThrowOnError extends boolean = false>(
  options: Options<ReviewDataTableChartData, ThrowOnError>,
): RequestResult<ReviewDataTableChartResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ReviewDataTableChartResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/charts/{chartId}/review',
    ...options,
  });

export const getDataTablePatentFieldValues = <ThrowOnError extends boolean = false>(
  options: Options<GetDataTablePatentFieldValuesData, ThrowOnError>,
): RequestResult<GetDataTablePatentFieldValuesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetDataTablePatentFieldValuesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/columns/{columnId}/patent-values',
    ...options,
  });

export const exportDataTable = <ThrowOnError extends boolean = false>(
  options: Options<ExportDataTableData, ThrowOnError>,
): RequestResult<ExportDataTableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ExportDataTableResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/export',
    ...options,
  });

export const reviewDataTableCells = <ThrowOnError extends boolean = false>(
  options: Options<ReviewDataTableCellsData, ThrowOnError>,
): RequestResult<ReviewDataTableCellsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReviewDataTableCellsResponses, unknown, ThrowOnError>({
    url: '/data-tables/{tableId}/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getDataTableRows = <ThrowOnError extends boolean = false>(
  options: Options<GetDataTableRowsData, ThrowOnError>,
): RequestResult<GetDataTableRowsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GetDataTableRowsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/rows',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getDataTableRowsByIds = <ThrowOnError extends boolean = false>(
  options: Options<GetDataTableRowsByIdsData, ThrowOnError>,
): RequestResult<GetDataTableRowsByIdsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GetDataTableRowsByIdsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/rows/by-ids',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const appendDataTableRows = <ThrowOnError extends boolean = false>(
  options: Options<AppendDataTableRowsData, ThrowOnError>,
): RequestResult<AppendDataTableRowsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AppendDataTableRowsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/data-tables/{tableId}/rows/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const composePromptPreview = <ThrowOnError extends boolean = false>(
  options: Options<ComposePromptPreviewData, ThrowOnError>,
): RequestResult<ComposePromptPreviewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ComposePromptPreviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/developer/compose-prompt-preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteModelProviderOverride = <ThrowOnError extends boolean = false>(
  options: Options<DeleteModelProviderOverrideData, ThrowOnError>,
): RequestResult<DeleteModelProviderOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteModelProviderOverrideResponses, unknown, ThrowOnError>({
    url: '/developer/model-provider-override',
    ...options,
  });

export const setModelProviderOverride = <ThrowOnError extends boolean = false>(
  options: Options<SetModelProviderOverrideData, ThrowOnError>,
): RequestResult<SetModelProviderOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SetModelProviderOverrideResponses, unknown, ThrowOnError>({
    url: '/developer/model-provider-override',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getDeveloperPromptFiles = <ThrowOnError extends boolean = false>(
  options?: Options<GetDeveloperPromptFilesData, ThrowOnError>,
): RequestResult<GetDeveloperPromptFilesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetDeveloperPromptFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/developer/prompt-files',
    ...options,
  });

export const deleteDeveloperPromptOverrides = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDeveloperPromptOverridesData, ThrowOnError>,
): RequestResult<DeleteDeveloperPromptOverridesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteDeveloperPromptOverridesResponses, unknown, ThrowOnError>({
    url: '/developer/prompt-overrides/{resourceType}/{resourceId}',
    ...options,
  });

export const getDeveloperPromptOverrides = <ThrowOnError extends boolean = false>(
  options: Options<GetDeveloperPromptOverridesData, ThrowOnError>,
): RequestResult<GetDeveloperPromptOverridesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetDeveloperPromptOverridesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/developer/prompt-overrides/{resourceType}/{resourceId}',
    ...options,
  });

export const putDeveloperPromptOverride = <ThrowOnError extends boolean = false>(
  options: Options<PutDeveloperPromptOverrideData, ThrowOnError>,
): RequestResult<PutDeveloperPromptOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutDeveloperPromptOverrideResponses, unknown, ThrowOnError>({
    url: '/developer/prompt-overrides/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getDeveloperRolesOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetDeveloperRolesOverviewData, ThrowOnError>,
): RequestResult<GetDeveloperRolesOverviewResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetDeveloperRolesOverviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/developer/roles-overview',
    ...options,
  });

export const documentCreationReviewEvent = <ThrowOnError extends boolean = false>(
  options: Options<DocumentCreationReviewEventData, ThrowOnError>,
): RequestResult<DocumentCreationReviewEventResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<DocumentCreationReviewEventResponses, unknown, ThrowOnError>({
    url: '/document-creation/event/{eventId}',
    ...options,
  });

export const documentsGetByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsGetByResourceIdData, ThrowOnError>,
): RequestResult<DocumentsGetByResourceIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DocumentsGetByResourceIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/resource/{resourceId}',
    ...options,
  });

export const documentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsCreateData, ThrowOnError>,
): RequestResult<DocumentsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DocumentsCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/resource/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const documentsDelete = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsDeleteData, ThrowOnError>,
): RequestResult<DocumentsDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DocumentsDeleteResponses, unknown, ThrowOnError>({
    url: '/document/{resourceType}/{storedDocumentId}',
    ...options,
  });

export const documentsGet = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsGetData, ThrowOnError>,
): RequestResult<DocumentsGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DocumentsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}',
    ...options,
  });

export const documentsPutContent = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsPutContentData, ThrowOnError>,
): RequestResult<DocumentsPutContentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<DocumentsPutContentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/content',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const documentsGetDocx = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsGetDocxData, ThrowOnError>,
): RequestResult<DocumentsGetDocxResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DocumentsGetDocxResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/docx',
    ...options,
  });

export const documentsPutDocx = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsPutDocxData, ThrowOnError>,
): RequestResult<DocumentsPutDocxResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<DocumentsPutDocxResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/docx',
    ...options,
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ...options.headers,
    },
  });

export const documentsCompleteDocxUpload = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsCompleteDocxUploadData, ThrowOnError>,
): RequestResult<DocumentsCompleteDocxUploadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DocumentsCompleteDocxUploadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/docx/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const documentsCreateDocxUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsCreateDocxUploadUrlData, ThrowOnError>,
): RequestResult<DocumentsCreateDocxUploadUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DocumentsCreateDocxUploadUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/docx/upload-url',
    ...options,
  });

export const documentsDuplicate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsDuplicateData, ThrowOnError>,
): RequestResult<DocumentsDuplicateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DocumentsDuplicateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/duplicate',
    ...options,
  });

export const documentsUpdateMetadata = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsUpdateMetadataData, ThrowOnError>,
): RequestResult<DocumentsUpdateMetadataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DocumentsUpdateMetadataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/document/{resourceType}/{storedDocumentId}/metadata',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listExternalSources = <ThrowOnError extends boolean = false>(
  options?: Options<ListExternalSourcesData, ThrowOnError>,
): RequestResult<ListExternalSourcesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListExternalSourcesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources',
    ...options,
  });

export const createExternalSource = <ThrowOnError extends boolean = false>(
  options: Options<CreateExternalSourceData, ThrowOnError>,
): RequestResult<CreateExternalSourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateExternalSourceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createExternalSourceAuth = <ThrowOnError extends boolean = false>(
  options: Options<CreateExternalSourceAuthData, ThrowOnError>,
): RequestResult<CreateExternalSourceAuthResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateExternalSourceAuthResponses, unknown, ThrowOnError>({
    url: '/external-sources/auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listExternalSourceConfigs = <ThrowOnError extends boolean = false>(
  options: Options<ListExternalSourceConfigsData, ThrowOnError>,
): RequestResult<ListExternalSourceConfigsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListExternalSourceConfigsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/configs',
    ...options,
  });

export const listExternalConnections = <ThrowOnError extends boolean = false>(
  options: Options<ListExternalConnectionsData, ThrowOnError>,
): RequestResult<ListExternalConnectionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListExternalConnectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/connections/{resourceType}/{resourceId}',
    ...options,
  });

export const createExternalConnections = <ThrowOnError extends boolean = false>(
  options: Options<CreateExternalConnectionsData, ThrowOnError>,
): RequestResult<CreateExternalConnectionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateExternalConnectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/connections/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteExternalConnection = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExternalConnectionData, ThrowOnError>,
): RequestResult<DeleteExternalConnectionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteExternalConnectionResponses, unknown, ThrowOnError>({
    url: '/external-sources/connections/{resourceType}/{resourceId}/{connectionId}',
    ...options,
  });

export const exportExternalSourceItems = <ThrowOnError extends boolean = false>(
  options: Options<ExportExternalSourceItemsData, ThrowOnError>,
): RequestResult<ExportExternalSourceItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExportExternalSourceItemsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/external-sources/exports/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const importExternalSourceFiles = <ThrowOnError extends boolean = false>(
  options: Options<ImportExternalSourceFilesData, ThrowOnError>,
): RequestResult<ImportExternalSourceFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ImportExternalSourceFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/imports/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const searchExternalSourceItems = <ThrowOnError extends boolean = false>(
  options: Options<SearchExternalSourceItemsData, ThrowOnError>,
): RequestResult<SearchExternalSourceItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SearchExternalSourceItemsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { type: { array: { explode: false } } } },
    responseType: 'json',
    url: '/external-sources/items',
    ...options,
  });

export const listExternalSourceItems = <ThrowOnError extends boolean = false>(
  options: Options<ListExternalSourceItemsData, ThrowOnError>,
): RequestResult<ListExternalSourceItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListExternalSourceItemsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/items/{resourceType}/{resourceId}',
    ...options,
  });

export const previewExternalSourceFile = <ThrowOnError extends boolean = false>(
  options: Options<PreviewExternalSourceFileData, ThrowOnError>,
): RequestResult<PreviewExternalSourceFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PreviewExternalSourceFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/items/{resourceType}/{resourceId}/preview',
    ...options,
  });

export const updateExternalSource = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExternalSourceData, ThrowOnError>,
): RequestResult<UpdateExternalSourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateExternalSourceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/external-sources/{sourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const setExternalSourceCredentials = <ThrowOnError extends boolean = false>(
  options: Options<SetExternalSourceCredentialsData, ThrowOnError>,
): RequestResult<SetExternalSourceCredentialsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SetExternalSourceCredentialsResponses, unknown, ThrowOnError>({
    url: '/external-sources/{sourceId}/credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getFeatureFlags = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeatureFlagsData, ThrowOnError>,
): RequestResult<GetFeatureFlagsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetFeatureFlagsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { 'flag-key': { array: { explode: false } } } },
    responseType: 'json',
    url: '/feature-flag',
    ...options,
  });

export const figureDiagramsReviewFigureDiagramEvent = <ThrowOnError extends boolean = false>(
  options: Options<FigureDiagramsReviewFigureDiagramEventData, ThrowOnError>,
): RequestResult<FigureDiagramsReviewFigureDiagramEventResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FigureDiagramsReviewFigureDiagramEventResponses, unknown, ThrowOnError>({
    url: '/figure-diagram/event/{eventId}',
    ...options,
  });

export const figureGenerationGenerateDiagram = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateDiagramData, ThrowOnError>,
): RequestResult<FigureGenerationGenerateDiagramResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateDiagramResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/diagram',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figureGenerationGenerateDiagramFromFile = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateDiagramFromFileData, ThrowOnError>,
): RequestResult<FigureGenerationGenerateDiagramFromFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateDiagramFromFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/diagram/from-file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figureGenerationGenerateDiagramFromFileV2 = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateDiagramFromFileV2Data, ThrowOnError>,
): RequestResult<FigureGenerationGenerateDiagramFromFileV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateDiagramFromFileV2Responses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/diagram/from-file/v2',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figureGenerationGenerateDiagramV2 = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateDiagramV2Data, ThrowOnError>,
): RequestResult<FigureGenerationGenerateDiagramV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateDiagramV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/diagram/v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figureGenerationGenerateImageFromFigure = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateImageFromFigureData, ThrowOnError>,
): RequestResult<FigureGenerationGenerateImageFromFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateImageFromFigureResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/image/from-figure',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figureGenerationGenerateImageFromFile = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateImageFromFileData, ThrowOnError>,
): RequestResult<FigureGenerationGenerateImageFromFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateImageFromFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/image/from-file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figureGenerationGenerateImageFromTempFile = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateImageFromTempFileData, ThrowOnError>,
): RequestResult<FigureGenerationGenerateImageFromTempFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateImageFromTempFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/image/from-temp-file',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figureGenerationGenerateImageFromTextV2 = <ThrowOnError extends boolean = false>(
  options: Options<FigureGenerationGenerateImageFromTextV2Data, ThrowOnError>,
): RequestResult<FigureGenerationGenerateImageFromTextV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FigureGenerationGenerateImageFromTextV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/generation/{resourceType}/{resourceId}/image/from-text-v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresGetFigures = <ThrowOnError extends boolean = false>(
  options: Options<FiguresGetFiguresData, ThrowOnError>,
): RequestResult<FiguresGetFiguresResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FiguresGetFiguresResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}',
    ...options,
  });

export const figuresBatchDeleteFigures = <ThrowOnError extends boolean = false>(
  options: Options<FiguresBatchDeleteFiguresData, ThrowOnError>,
): RequestResult<FiguresBatchDeleteFiguresResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FiguresBatchDeleteFiguresResponses, unknown, ThrowOnError>({
    url: '/figure/{resourceType}/{resourceId}/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresExportFigureToVisio = <ThrowOnError extends boolean = false>(
  options: Options<FiguresExportFigureToVisioData, ThrowOnError>,
): RequestResult<FiguresExportFigureToVisioResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresExportFigureToVisioResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/export/visio',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresBatchExportFiguresToVisio = <ThrowOnError extends boolean = false>(
  options: Options<FiguresBatchExportFiguresToVisioData, ThrowOnError>,
): RequestResult<FiguresBatchExportFiguresToVisioResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresBatchExportFiguresToVisioResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/export/visio/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresExportFigureToVisioV2 = <ThrowOnError extends boolean = false>(
  options: Options<FiguresExportFigureToVisioV2Data, ThrowOnError>,
): RequestResult<FiguresExportFigureToVisioV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresExportFigureToVisioV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/export/visio/v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresBatchImportFromFile = <ThrowOnError extends boolean = false>(
  options: Options<FiguresBatchImportFromFileData, ThrowOnError>,
): RequestResult<FiguresBatchImportFromFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresBatchImportFromFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/import-from-file',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresReorderFigures = <ThrowOnError extends boolean = false>(
  options: Options<FiguresReorderFiguresData, ThrowOnError>,
): RequestResult<FiguresReorderFiguresResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FiguresReorderFiguresResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/order',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const figuresSaveFigure = <ThrowOnError extends boolean = false>(
  options: Options<FiguresSaveFigureData, ThrowOnError>,
): RequestResult<FiguresSaveFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresSaveFigureResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/save',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figuresUploadFigure = <ThrowOnError extends boolean = false>(
  options: Options<FiguresUploadFigureData, ThrowOnError>,
): RequestResult<FiguresUploadFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresUploadFigureResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figuresUploadFiguresBatch = <ThrowOnError extends boolean = false>(
  options: Options<FiguresUploadFiguresBatchData, ThrowOnError>,
): RequestResult<FiguresUploadFiguresBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FiguresUploadFiguresBatchResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/upload/batch',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const figuresDeleteFigure = <ThrowOnError extends boolean = false>(
  options: Options<FiguresDeleteFigureData, ThrowOnError>,
): RequestResult<FiguresDeleteFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FiguresDeleteFigureResponses, unknown, ThrowOnError>({
    url: '/figure/{resourceType}/{resourceId}/{figureId}',
    ...options,
  });

export const figuresGetFigure = <ThrowOnError extends boolean = false>(
  options: Options<FiguresGetFigureData, ThrowOnError>,
): RequestResult<FiguresGetFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FiguresGetFigureResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/figure/{resourceType}/{resourceId}/{figureId}',
    ...options,
  });

export const figuresUpdateFigureInfo = <ThrowOnError extends boolean = false>(
  options: Options<FiguresUpdateFigureInfoData, ThrowOnError>,
): RequestResult<FiguresUpdateFigureInfoResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FiguresUpdateFigureInfoResponses, unknown, ThrowOnError>({
    url: '/figure/{resourceType}/{resourceId}/{figureId}/info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const fileFolderDelete = <ThrowOnError extends boolean = false>(
  options: Options<FileFolderDeleteData, ThrowOnError>,
): RequestResult<FileFolderDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FileFolderDeleteResponses, unknown, ThrowOnError>({
    url: '/file-folders/{folderId}',
    ...options,
  });

/**
 * @deprecated
 */
export const fileFolderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FileFolderUpdateData, ThrowOnError>,
): RequestResult<FileFolderUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FileFolderUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file-folders/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const fileFolderAddItems = <ThrowOnError extends boolean = false>(
  options: Options<FileFolderAddItemsData, ThrowOnError>,
): RequestResult<FileFolderAddItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FileFolderAddItemsResponses, unknown, ThrowOnError>({
    url: '/file-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const fileFolderGetAll = <ThrowOnError extends boolean = false>(
  options: Options<FileFolderGetAllData, ThrowOnError>,
): RequestResult<FileFolderGetAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileFolderGetAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file-folders/{resourceType}/{resourceId}',
    ...options,
  });

/**
 * @deprecated
 */
export const fileFolderCreate = <ThrowOnError extends boolean = false>(
  options: Options<FileFolderCreateData, ThrowOnError>,
): RequestResult<FileFolderCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileFolderCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file-folders/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fileUploadByPatentNumberV2 = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadByPatentNumberV2Data, ThrowOnError>,
): RequestResult<FileUploadByPatentNumberV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileUploadByPatentNumberV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/upload-by-patent-number-v2/{resourceType}/{workflowId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fileUpload = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadData, ThrowOnError>,
): RequestResult<FileUploadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/file/upload/{resourceType}/{workflowId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const fileDelete = <ThrowOnError extends boolean = false>(
  options: Options<FileDeleteData, ThrowOnError>,
): RequestResult<FileDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FileDeleteResponses, unknown, ThrowOnError>({ url: '/file/{fileId}', ...options });

export const fileGet = <ThrowOnError extends boolean = false>(
  options: Options<FileGetData, ThrowOnError>,
): RequestResult<FileGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{fileId}',
    ...options,
  });

export const fileUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FileUpdateData, ThrowOnError>,
): RequestResult<FileUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FileUpdateResponses, unknown, ThrowOnError>({
    url: '/file/{fileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fileUploadContent = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadContentData, ThrowOnError>,
): RequestResult<FileUploadContentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<FileUploadContentResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/file/{fileId}/content',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const fileExtractPdfImages = <ThrowOnError extends boolean = false>(
  options: Options<FileExtractPdfImagesData, ThrowOnError>,
): RequestResult<FileExtractPdfImagesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileExtractPdfImagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{fileId}/extract-pdf-images',
    ...options,
  });

export const fileGetFigures = <ThrowOnError extends boolean = false>(
  options: Options<FileGetFiguresData, ThrowOnError>,
): RequestResult<FileGetFiguresResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetFiguresResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{fileId}/figures',
    ...options,
  });

export const fileGetHighlights = <ThrowOnError extends boolean = false>(
  options: Options<FileGetHighlightsData, ThrowOnError>,
): RequestResult<FileGetHighlightsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetHighlightsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { type: { array: { explode: false } } } },
    responseType: 'json',
    url: '/file/{fileId}/highlights',
    ...options,
  });

export const fileGenerateSummary = <ThrowOnError extends boolean = false>(
  options: Options<FileGenerateSummaryData, ThrowOnError>,
): RequestResult<FileGenerateSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileGenerateSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{fileId}/summary',
    ...options,
  });

export const fileGetUrl = <ThrowOnError extends boolean = false>(
  options: Options<FileGetUrlData, ThrowOnError>,
): RequestResult<FileGetUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{fileId}/url',
    ...options,
  });

export const fileExtractPatentFromFile = <ThrowOnError extends boolean = false>(
  options: Options<FileExtractPatentFromFileData, ThrowOnError>,
): RequestResult<FileExtractPatentFromFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileExtractPatentFromFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{resourceType}/{resourceId}/extract-patent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fileReviewExtractedPatentFromFile = <ThrowOnError extends boolean = false>(
  options: Options<FileReviewExtractedPatentFromFileData, ThrowOnError>,
): RequestResult<FileReviewExtractedPatentFromFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FileReviewExtractedPatentFromFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{resourceType}/{resourceId}/extract-patent-suggestion/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const fileGetWorkflowFiles = <ThrowOnError extends boolean = false>(
  options: Options<FileGetWorkflowFilesData, ThrowOnError>,
): RequestResult<FileGetWorkflowFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetWorkflowFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{resourceType}/{workflowId}',
    ...options,
  });

export const fileGetFigureFileCandidates = <ThrowOnError extends boolean = false>(
  options: Options<FileGetFigureFileCandidatesData, ThrowOnError>,
): RequestResult<FileGetFigureFileCandidatesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<FileGetFigureFileCandidatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/file/{resourceType}/{workflowId}/figure-candidates',
    ...options,
  });

export const createForm = <ThrowOnError extends boolean = false>(
  options: Options<CreateFormData, ThrowOnError>,
): RequestResult<CreateFormResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateFormResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/forms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteForm = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFormData, ThrowOnError>,
): RequestResult<DeleteFormResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteFormResponses, unknown, ThrowOnError>({ url: '/forms/{formId}', ...options });

export const getForm = <ThrowOnError extends boolean = false>(
  options: Options<GetFormData, ThrowOnError>,
): RequestResult<GetFormResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetFormResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/forms/{formId}',
    ...options,
  });

export const saveFormAnswers = <ThrowOnError extends boolean = false>(
  options: Options<SaveFormAnswersData, ThrowOnError>,
): RequestResult<SaveFormAnswersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SaveFormAnswersResponses, unknown, ThrowOnError>({
    url: '/forms/{formId}/answers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const exportForm = <ThrowOnError extends boolean = false>(
  options: Options<ExportFormData, ThrowOnError>,
): RequestResult<ExportFormResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExportFormResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/forms/{formId}/export',
    ...options,
  });

export const listForms = <ThrowOnError extends boolean = false>(
  options: Options<ListFormsData, ThrowOnError>,
): RequestResult<ListFormsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListFormsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/forms/{resourceType}/{resourceId}',
    ...options,
  });

export const getGeneralAssistants = <ThrowOnError extends boolean = false>(
  options?: Options<GetGeneralAssistantsData, ThrowOnError>,
): RequestResult<GetGeneralAssistantsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetGeneralAssistantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/general-assistant',
    ...options,
  });

/**
 * @deprecated
 */
export const createGeneralAssistant = <ThrowOnError extends boolean = false>(
  options: Options<CreateGeneralAssistantData, ThrowOnError>,
): RequestResult<CreateGeneralAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateGeneralAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/general-assistant',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const setupOfficeAction = <ThrowOnError extends boolean = false>(
  options: Options<SetupOfficeActionData, ThrowOnError>,
): RequestResult<SetupOfficeActionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SetupOfficeActionResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/general-assistant/setup/office-action',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const createGeneralAssistantV2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateGeneralAssistantV2Data, ThrowOnError>,
): RequestResult<CreateGeneralAssistantV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateGeneralAssistantV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/general-assistant/v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteGeneralAssistant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGeneralAssistantData, ThrowOnError>,
): RequestResult<DeleteGeneralAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteGeneralAssistantResponses, unknown, ThrowOnError>({
    url: '/general-assistant/{id}',
    ...options,
  });

export const getGeneralAssistant = <ThrowOnError extends boolean = false>(
  options: Options<GetGeneralAssistantData, ThrowOnError>,
): RequestResult<GetGeneralAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetGeneralAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/general-assistant/{id}',
    ...options,
  });

export const updateGeneralAssistant = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGeneralAssistantData, ThrowOnError>,
): RequestResult<UpdateGeneralAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateGeneralAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/general-assistant/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const glossarySearchRelatedTerms = <ThrowOnError extends boolean = false>(
  options: Options<GlossarySearchRelatedTermsData, ThrowOnError>,
): RequestResult<GlossarySearchRelatedTermsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GlossarySearchRelatedTermsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/glossary/{resourceType}/{resourceId}/search-related-terms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const glossarySearchTermDefinitions = <ThrowOnError extends boolean = false>(
  options: Options<GlossarySearchTermDefinitionsData, ThrowOnError>,
): RequestResult<GlossarySearchTermDefinitionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GlossarySearchTermDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/glossary/{resourceType}/{resourceId}/search-term-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getInventionAssistants = <ThrowOnError extends boolean = false>(
  options?: Options<GetInventionAssistantsData, ThrowOnError>,
): RequestResult<GetInventionAssistantsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetInventionAssistantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/invention-assistant',
    ...options,
  });

export const createInventionAssistant = <ThrowOnError extends boolean = false>(
  options: Options<CreateInventionAssistantData, ThrowOnError>,
): RequestResult<CreateInventionAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateInventionAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/invention-assistant',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteInventionAssistant = <ThrowOnError extends boolean = false>(
  options: Options<DeleteInventionAssistantData, ThrowOnError>,
): RequestResult<DeleteInventionAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteInventionAssistantResponses, unknown, ThrowOnError>({
    url: '/invention-assistant/{id}',
    ...options,
  });

export const getInventionAssistant = <ThrowOnError extends boolean = false>(
  options: Options<GetInventionAssistantData, ThrowOnError>,
): RequestResult<GetInventionAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetInventionAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/invention-assistant/{id}',
    ...options,
  });

export const updateInventionAssistant = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInventionAssistantData, ThrowOnError>,
): RequestResult<UpdateInventionAssistantResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateInventionAssistantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/invention-assistant/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderDelete = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderDeleteData, ThrowOnError>,
): RequestResult<ItemFolderDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ItemFolderDeleteResponses, unknown, ThrowOnError>({
    url: '/item-folders/{folderId}',
    ...options,
  });

export const itemFolderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderUpdateData, ThrowOnError>,
): RequestResult<ItemFolderUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ItemFolderUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/item-folders/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderAddItems = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderAddItemsData, ThrowOnError>,
): RequestResult<ItemFolderAddItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ItemFolderAddItemsResponses, unknown, ThrowOnError>({
    url: '/item-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderGetAll = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderGetAllData, ThrowOnError>,
): RequestResult<ItemFolderGetAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ItemFolderGetAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/item-folders/{resourceType}/{resourceId}',
    ...options,
  });

export const itemFolderCreate = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderCreateData, ThrowOnError>,
): RequestResult<ItemFolderCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ItemFolderCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/item-folders/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeList = <ThrowOnError extends boolean = false>(
  options?: Options<KnowledgeListData, ThrowOnError>,
): RequestResult<KnowledgeListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<KnowledgeListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge',
    ...options,
  });

export const knowledgeCreate = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeCreateData, ThrowOnError>,
): RequestResult<KnowledgeCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<KnowledgeCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeFolderGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<KnowledgeFolderGetAllData, ThrowOnError>,
): RequestResult<KnowledgeFolderGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<KnowledgeFolderGetAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge-folders',
    ...options,
  });

export const knowledgeFolderCreate = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderCreateData, ThrowOnError>,
): RequestResult<KnowledgeFolderCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<KnowledgeFolderCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge-folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeFolderDelete = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderDeleteData, ThrowOnError>,
): RequestResult<KnowledgeFolderDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<KnowledgeFolderDeleteResponses, unknown, ThrowOnError>({
    url: '/knowledge-folders/{folderId}',
    ...options,
  });

export const knowledgeFolderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderUpdateData, ThrowOnError>,
): RequestResult<KnowledgeFolderUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeFolderUpdateResponses, unknown, ThrowOnError>({
    url: '/knowledge-folders/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeFolderActivate = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderActivateData, ThrowOnError>,
): RequestResult<KnowledgeFolderActivateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeFolderActivateResponses, unknown, ThrowOnError>({
    url: '/knowledge-folders/{folderId}/activate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeFolderRemoveItems = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderRemoveItemsData, ThrowOnError>,
): RequestResult<KnowledgeFolderRemoveItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<KnowledgeFolderRemoveItemsResponses, unknown, ThrowOnError>({
    url: '/knowledge-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeFolderAddItems = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeFolderAddItemsData, ThrowOnError>,
): RequestResult<KnowledgeFolderAddItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeFolderAddItemsResponses, unknown, ThrowOnError>({
    url: '/knowledge-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeGetEvent = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeGetEventData, ThrowOnError>,
): RequestResult<KnowledgeGetEventResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<KnowledgeGetEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge/event/{eventId}',
    ...options,
  });

export const knowledgeReviewEvent = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeReviewEventData, ThrowOnError>,
): RequestResult<KnowledgeReviewEventResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeReviewEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge/event/{eventId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeGenerateDescription = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeGenerateDescriptionData, ThrowOnError>,
): RequestResult<KnowledgeGenerateDescriptionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<KnowledgeGenerateDescriptionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge/generate-description',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeDelete = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeDeleteData, ThrowOnError>,
): RequestResult<KnowledgeDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<KnowledgeDeleteResponses, unknown, ThrowOnError>({
    url: '/knowledge/{id}',
    ...options,
  });

export const knowledgeGet = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeGetData, ThrowOnError>,
): RequestResult<KnowledgeGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<KnowledgeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge/{id}',
    ...options,
  });

export const knowledgeUpdate = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeUpdateData, ThrowOnError>,
): RequestResult<KnowledgeUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/knowledge/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeSetActive = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeSetActiveData, ThrowOnError>,
): RequestResult<KnowledgeSetActiveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeSetActiveResponses, unknown, ThrowOnError>({
    url: '/knowledge/{id}/active',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const knowledgeSetAutoLoad = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeSetAutoLoadData, ThrowOnError>,
): RequestResult<KnowledgeSetAutoLoadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<KnowledgeSetAutoLoadResponses, unknown, ThrowOnError>({
    url: '/knowledge/{id}/auto-load',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getOverlapAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<GetOverlapAnalysisData, ThrowOnError>,
): RequestResult<GetOverlapAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetOverlapAnalysisResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/analysis-result/{resultId}/overlap-analysis',
    ...options,
  });

export const getOverlapAnalysisStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetOverlapAnalysisStatusData, ThrowOnError>,
): RequestResult<GetOverlapAnalysisStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetOverlapAnalysisStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/analysis-result/{resultId}/overlap-analysis/status',
    ...options,
  });

export const updateNoveltyAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNoveltyAnalysisData, ThrowOnError>,
): RequestResult<UpdateNoveltyAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateNoveltyAnalysisResponses, unknown, ThrowOnError>({
    url: '/novelty-analysis/analysis/{analysisId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const cancelNoveltyAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<CancelNoveltyAnalysisData, ThrowOnError>,
): RequestResult<CancelNoveltyAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CancelNoveltyAnalysisResponses, unknown, ThrowOnError>({
    url: '/novelty-analysis/analysis/{analysisId}/cancel',
    ...options,
  });

export const getNoveltyAnalysisFeatures = <ThrowOnError extends boolean = false>(
  options: Options<GetNoveltyAnalysisFeaturesData, ThrowOnError>,
): RequestResult<GetNoveltyAnalysisFeaturesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetNoveltyAnalysisFeaturesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/analysis/{analysisId}/features',
    ...options,
  });

export const getNoveltyAnalysisResults = <ThrowOnError extends boolean = false>(
  options: Options<GetNoveltyAnalysisResultsData, ThrowOnError>,
): RequestResult<GetNoveltyAnalysisResultsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetNoveltyAnalysisResultsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/analysis/{analysisId}/results',
    ...options,
  });

export const getNoveltyAnalysisStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetNoveltyAnalysisStatusData, ThrowOnError>,
): RequestResult<GetNoveltyAnalysisStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetNoveltyAnalysisStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/analysis/{analysisId}/status',
    ...options,
  });

export const reviewSearchSuggestion = <ThrowOnError extends boolean = false>(
  options: Options<ReviewSearchSuggestionData, ThrowOnError>,
): RequestResult<ReviewSearchSuggestionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ReviewSearchSuggestionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/search-suggestion/{suggestionId}',
    ...options,
  });

export const getNoveltyAnalyses = <ThrowOnError extends boolean = false>(
  options: Options<GetNoveltyAnalysesData, ThrowOnError>,
): RequestResult<GetNoveltyAnalysesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetNoveltyAnalysesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/{resourceType}/{resourceId}/analyses',
    ...options,
  });

export const createNoveltyAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<CreateNoveltyAnalysisData, ThrowOnError>,
): RequestResult<CreateNoveltyAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateNoveltyAnalysisResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/novelty-analysis/{resourceType}/{resourceId}/analysis/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getNoveltyFeatures = <ThrowOnError extends boolean = false>(
  options: Options<GetNoveltyFeaturesData, ThrowOnError>,
): RequestResult<GetNoveltyFeaturesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetNoveltyFeaturesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/{resourceType}/{resourceId}/features',
    ...options,
  });

export const featurizeNoveltyAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<FeaturizeNoveltyAnalysisData, ThrowOnError>,
): RequestResult<FeaturizeNoveltyAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FeaturizeNoveltyAnalysisResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/novelty-analysis/{resourceType}/{resourceId}/features',
    ...options,
  });

export const updateNoveltyFeatures = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNoveltyFeaturesData, ThrowOnError>,
): RequestResult<UpdateNoveltyFeaturesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateNoveltyFeaturesResponses, unknown, ThrowOnError>({
    url: '/novelty-analysis/{resourceType}/{resourceId}/features',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteObjectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<DeleteObjectionStatusData, ThrowOnError>,
): RequestResult<DeleteObjectionStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DeleteObjectionStatusResponses, unknown, ThrowOnError>({
    url: '/office-actions-2/objection/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const bulkRerunObjectionAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<BulkRerunObjectionAnalysisData, ThrowOnError>,
): RequestResult<BulkRerunObjectionAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<BulkRerunObjectionAnalysisResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/office-actions-2/objection/rerun',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const declineSuggestion = <ThrowOnError extends boolean = false>(
  options: Options<DeclineSuggestionData, ThrowOnError>,
): RequestResult<DeclineSuggestionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DeclineSuggestionResponses, unknown, ThrowOnError>({
    url: '/office-actions-2/objection/suggestion/{suggestionId}/decline',
    ...options,
  });

export const updateObjectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateObjectionStatusData, ThrowOnError>,
): RequestResult<UpdateObjectionStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdateObjectionStatusResponses, unknown, ThrowOnError>({
    url: '/office-actions-2/objection/update-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getObjection = <ThrowOnError extends boolean = false>(
  options: Options<GetObjectionData, ThrowOnError>,
): RequestResult<GetObjectionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetObjectionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/office-actions-2/objection/{objectionIdentityId}',
    ...options,
  });

export const rerunObjectionAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<RerunObjectionAnalysisData, ThrowOnError>,
): RequestResult<RerunObjectionAnalysisResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<RerunObjectionAnalysisResponses, unknown, ThrowOnError>({
    url: '/office-actions-2/objection/{objectionIdentityId}/rerun',
    ...options,
  });

export const getObjectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetObjectionStatusData, ThrowOnError>,
): RequestResult<GetObjectionStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetObjectionStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/office-actions-2/objection/{objectionIdentityId}/status',
    ...options,
  });

export const getSuggestions = <ThrowOnError extends boolean = false>(
  options: Options<GetSuggestionsData, ThrowOnError>,
): RequestResult<GetSuggestionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetSuggestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/office-actions-2/objection/{objectionIdentityId}/suggestion',
    ...options,
  });

/**
 * Counts every unarchived project owned by a member of the caller's organisation, whether or not the caller can open it.
 *
 * @deprecated
 */
export const orgProjectAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<OrgProjectAnalyticsData, ThrowOnError>,
): RequestResult<OrgProjectAnalyticsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrgProjectAnalyticsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { type: { array: { explode: false } } } },
    responseType: 'json',
    url: '/org-admin/projects/analytics',
    ...options,
  });

/**
 * As `analytics`, narrowed by the same filters as the hub.
 */
export const orgProjectQueryAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<OrgProjectQueryAnalyticsData, ThrowOnError>,
): RequestResult<OrgProjectQueryAnalyticsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrgProjectQueryAnalyticsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/org-admin/projects/analytics/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getPatentDrafts = <ThrowOnError extends boolean = false>(
  options: Options<GetPatentDraftsData, ThrowOnError>,
): RequestResult<GetPatentDraftsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPatentDraftsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft',
    ...options,
  });

export const createPatentDraft = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatentDraftData, ThrowOnError>,
): RequestResult<CreatePatentDraftResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreatePatentDraftResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/patent-draft',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const archivePatentDrafts = <ThrowOnError extends boolean = false>(
  options: Options<ArchivePatentDraftsData, ThrowOnError>,
): RequestResult<ArchivePatentDraftsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ArchivePatentDraftsResponses, unknown, ThrowOnError>({
    url: '/patent-draft/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createPatentDraftFromDisclosure = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatentDraftFromDisclosureData, ThrowOnError>,
): RequestResult<CreatePatentDraftFromDisclosureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreatePatentDraftFromDisclosureResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/patent-draft/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putPatentDraftDraftingMode = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftDraftingModeData, ThrowOnError>,
): RequestResult<PutPatentDraftDraftingModeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftDraftingModeResponses, unknown, ThrowOnError>({
    url: '/patent-draft/drafting-mode',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const batchDeletePatentDraftFiles = <ThrowOnError extends boolean = false>(
  options: Options<BatchDeletePatentDraftFilesData, ThrowOnError>,
): RequestResult<BatchDeletePatentDraftFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<BatchDeletePatentDraftFilesResponses, unknown, ThrowOnError>({
    url: '/patent-draft/file/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createPatentDraftFileByPatentNumberV2 = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatentDraftFileByPatentNumberV2Data, ThrowOnError>,
): RequestResult<CreatePatentDraftFileByPatentNumberV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreatePatentDraftFileByPatentNumberV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/file/upload-by-patent-number-v2/{patentDraftFileType}/{patentDraftId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createPatentDraftFile = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatentDraftFileData, ThrowOnError>,
): RequestResult<CreatePatentDraftFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreatePatentDraftFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/file/upload/{patentDraftFileType}/{patentDraftId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const deletePatentDraftFile = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatentDraftFileData, ThrowOnError>,
): RequestResult<DeletePatentDraftFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeletePatentDraftFileResponses, unknown, ThrowOnError>({
    url: '/patent-draft/file/{fileId}',
    ...options,
  });

export const queueFileForOcr = <ThrowOnError extends boolean = false>(
  options: Options<QueueFileForOcrData, ThrowOnError>,
): RequestResult<QueueFileForOcrResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<QueueFileForOcrResponses, unknown, ThrowOnError>({
    url: '/patent-draft/file/{fileId}/queue-ocr',
    ...options,
  });

export const updatePatentDraftFileInfo = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatentDraftFileInfoData, ThrowOnError>,
): RequestResult<UpdatePatentDraftFileInfoResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdatePatentDraftFileInfoResponses, unknown, ThrowOnError>({
    url: '/patent-draft/file/{fileId}/update-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getPatentDraftFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetPatentDraftFilesData, ThrowOnError>,
): RequestResult<GetPatentDraftFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPatentDraftFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/file/{patentDraftId}',
    ...options,
  });

/**
 * @deprecated
 */
export const parseCdxCml = <ThrowOnError extends boolean = false>(
  options: Options<ParseCdxCmlData, ThrowOnError>,
): RequestResult<ParseCdxCmlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ParseCdxCmlResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/file/{patentDraftId}/convert-chemdraw',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const extractCompoundsFromDocx = <ThrowOnError extends boolean = false>(
  options: Options<ExtractCompoundsFromDocxData, ThrowOnError>,
): RequestResult<ExtractCompoundsFromDocxResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExtractCompoundsFromDocxResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/file/{patentDraftId}/extract-cdx-cml',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const extractSpreadsheet = <ThrowOnError extends boolean = false>(
  options: Options<ExtractSpreadsheetData, ThrowOnError>,
): RequestResult<ExtractSpreadsheetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExtractSpreadsheetResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/file/{patentDraftId}/extract-spreadsheet',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const putPatentDraftInventionDescription = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftInventionDescriptionData, ThrowOnError>,
): RequestResult<PutPatentDraftInventionDescriptionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftInventionDescriptionResponses, unknown, ThrowOnError>({
    url: '/patent-draft/invention-description',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putPatentDraftJurisdiction = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftJurisdictionData, ThrowOnError>,
): RequestResult<PutPatentDraftJurisdictionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftJurisdictionResponses, unknown, ThrowOnError>({
    url: '/patent-draft/jurisdiction',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getJurisdictionLanguages = <ThrowOnError extends boolean = false>(
  options?: Options<GetJurisdictionLanguagesData, ThrowOnError>,
): RequestResult<GetJurisdictionLanguagesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetJurisdictionLanguagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/jurisdiction-languages',
    ...options,
  });

export const putPatentDraftLanguage = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftLanguageData, ThrowOnError>,
): RequestResult<PutPatentDraftLanguageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftLanguageResponses, unknown, ThrowOnError>({
    url: '/patent-draft/language',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putPatentDraftName = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftNameData, ThrowOnError>,
): RequestResult<PutPatentDraftNameResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftNameResponses, unknown, ThrowOnError>({
    url: '/patent-draft/name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const addPatentDraftReferencePatentFile = <ThrowOnError extends boolean = false>(
  options: Options<AddPatentDraftReferencePatentFileData, ThrowOnError>,
): RequestResult<AddPatentDraftReferencePatentFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<AddPatentDraftReferencePatentFileResponses, unknown, ThrowOnError>({
    url: '/patent-draft/reference-patents/file',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putPatentDraftReferencePatentIds = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftReferencePatentIdsData, ThrowOnError>,
): RequestResult<PutPatentDraftReferencePatentIdsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftReferencePatentIdsResponses, unknown, ThrowOnError>({
    url: '/patent-draft/reference-patents/patent-ids',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentDraftSequenceMolTypeList = <ThrowOnError extends boolean = false>(
  options?: Options<PatentDraftSequenceMolTypeListData, ThrowOnError>,
): RequestResult<PatentDraftSequenceMolTypeListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PatentDraftSequenceMolTypeListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/sequences/mol-types',
    ...options,
  });

export const getPatentDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetPatentDraftData, ThrowOnError>,
): RequestResult<GetPatentDraftResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetPatentDraftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}',
    ...options,
  });

export const putContent = <ThrowOnError extends boolean = false>(
  options: Options<PutContentData, ThrowOnError>,
): RequestResult<PutContentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutContentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/content',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putContentWithComments = <ThrowOnError extends boolean = false>(
  options: Options<PutContentWithCommentsData, ThrowOnError>,
): RequestResult<PutContentWithCommentsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutContentWithCommentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/content/comments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putPatentDraftCustomInstructionsId = <ThrowOnError extends boolean = false>(
  options: Options<PutPatentDraftCustomInstructionsIdData, ThrowOnError>,
): RequestResult<PutPatentDraftCustomInstructionsIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutPatentDraftCustomInstructionsIdResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/custom-instructions-id',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteTrackedChanges = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTrackedChangesData, ThrowOnError>,
): RequestResult<DeleteTrackedChangesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteTrackedChangesResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/delete-tracked-changes',
    ...options,
  });

export const exportDraft = <ThrowOnError extends boolean = false>(
  options: Options<ExportDraftData, ThrowOnError>,
): RequestResult<ExportDraftResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExportDraftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/export',
    ...options,
  });

export const generateDraft = <ThrowOnError extends boolean = false>(
  options: Options<GenerateDraftData, ThrowOnError>,
): RequestResult<GenerateDraftResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GenerateDraftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/generate',
    ...options,
  });

export const initTrackedChanges = <ThrowOnError extends boolean = false>(
  options: Options<InitTrackedChangesData, ThrowOnError>,
): RequestResult<InitTrackedChangesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InitTrackedChangesResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/init-tracked-changes',
    ...options,
  });

export const deletePatentDraftReferencePatentFile = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatentDraftReferencePatentFileData, ThrowOnError>,
): RequestResult<DeletePatentDraftReferencePatentFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeletePatentDraftReferencePatentFileResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/reference-patents/file/{fileId}',
    ...options,
  });

export const patentDraftSequencesDeleteAll = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesDeleteAllData, ThrowOnError>,
): RequestResult<PatentDraftSequencesDeleteAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PatentDraftSequencesDeleteAllResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/sequences',
    ...options,
  });

export const patentDraftSequencesList = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesListData, ThrowOnError>,
): RequestResult<PatentDraftSequencesListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PatentDraftSequencesListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences',
    ...options,
  });

export const patentDraftSequencesCreate = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesCreateData, ThrowOnError>,
): RequestResult<PatentDraftSequencesCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PatentDraftSequencesCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentDraftSequencesDeleteBatch = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesDeleteBatchData, ThrowOnError>,
): RequestResult<PatentDraftSequencesDeleteBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PatentDraftSequencesDeleteBatchResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/sequences/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentDraftSequencesBatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesBatchCreateData, ThrowOnError>,
): RequestResult<PatentDraftSequencesBatchCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PatentDraftSequencesBatchCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentDraftSequencesBulkRenumber = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesBulkRenumberData, ThrowOnError>,
): RequestResult<PatentDraftSequencesBulkRenumberResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PatentDraftSequencesBulkRenumberResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/sequences/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentDraftSequencesExport = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesExportData, ThrowOnError>,
): RequestResult<PatentDraftSequencesExportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PatentDraftSequencesExportResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/patent-draft/{patentDraftId}/sequences/export',
    ...options,
  });

export const patentDraftSequencesExtractFromTabularFile = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesExtractFromTabularFileData, ThrowOnError>,
): RequestResult<PatentDraftSequencesExtractFromTabularFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PatentDraftSequencesExtractFromTabularFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/extract-from-tabular-file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const patentDraftSequencesImportSequences = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesImportSequencesData, ThrowOnError>,
): RequestResult<PatentDraftSequencesImportSequencesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PatentDraftSequencesImportSequencesResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/import',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const parseModifications = <ThrowOnError extends boolean = false>(
  options: Options<ParseModificationsData, ThrowOnError>,
): RequestResult<ParseModificationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ParseModificationsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/parse-modifications',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const patentDraftSequencesGet = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesGetData, ThrowOnError>,
): RequestResult<PatentDraftSequencesGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PatentDraftSequencesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/{sequenceId}',
    ...options,
  });

export const patentDraftSequencesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PatentDraftSequencesUpdateData, ThrowOnError>,
): RequestResult<PatentDraftSequencesUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PatentDraftSequencesUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-draft/{patentDraftId}/sequences/{sequenceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const putTemplate = <ThrowOnError extends boolean = false>(
  options: Options<PutTemplateData, ThrowOnError>,
): RequestResult<PutTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutTemplateResponses, unknown, ThrowOnError>({
    url: '/patent-draft/{patentDraftId}/template',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listPatentFamilyMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListPatentFamilyMembersData, ThrowOnError>,
): RequestResult<ListPatentFamilyMembersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ListPatentFamilyMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-office/family/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const patentOfficeFileImportFiles = <ThrowOnError extends boolean = false>(
  options: Options<PatentOfficeFileImportFilesData, ThrowOnError>,
): RequestResult<PatentOfficeFileImportFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PatentOfficeFileImportFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/patent-office/file/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deletes the field and every value stored for it.
 */
export const deleteAdminCustomField = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminCustomFieldData, ThrowOnError>,
): RequestResult<DeleteAdminCustomFieldResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteAdminCustomFieldResponses, unknown, ThrowOnError>({
    url: '/platform-admin/custom-fields/{fieldId}',
    ...options,
  });

/**
 * Replaces the field's settings. Its type can't change. Stored values that no longer fit, such as removed options, are left in place and hidden when read.
 */
export const updateAdminCustomField = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminCustomFieldData, ThrowOnError>,
): RequestResult<UpdateAdminCustomFieldResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateAdminCustomFieldResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/platform-admin/custom-fields/{fieldId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listAdminCustomFields = <ThrowOnError extends boolean = false>(
  options: Options<ListAdminCustomFieldsData, ThrowOnError>,
): RequestResult<ListAdminCustomFieldsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListAdminCustomFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/platform-admin/organization/{organizationId}/custom-fields',
    ...options,
  });

/**
 * Creates every field or none: nothing is saved if any field is invalid.
 */
export const createAdminCustomFields = <ThrowOnError extends boolean = false>(
  options: Options<CreateAdminCustomFieldsData, ThrowOnError>,
): RequestResult<CreateAdminCustomFieldsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateAdminCustomFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/platform-admin/organization/{organizationId}/custom-fields/{resourceType}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Every setting configurable for an organization, with the overrides applied to it.
 */
export const getOrganizationSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganizationSettingsData, ThrowOnError>,
): RequestResult<GetOrganizationSettingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetOrganizationSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/platform-admin/organization/{organizationId}/settings',
    ...options,
  });

/**
 * Applies a set of changes and returns every setting as it now stands.
 */
export const updateOrganizationSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganizationSettingsData, ThrowOnError>,
): RequestResult<UpdateOrganizationSettingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UpdateOrganizationSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/platform-admin/organization/{organizationId}/settings/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectFolderGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectFolderGetAllData, ThrowOnError>,
): RequestResult<ProjectFolderGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProjectFolderGetAllResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { access: { array: { explode: false } } } },
    responseType: 'json',
    url: '/project-folders',
    ...options,
  });

export const projectFolderCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderCreateData, ThrowOnError>,
): RequestResult<ProjectFolderCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectFolderCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/project-folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectFolderDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderDeleteData, ThrowOnError>,
): RequestResult<ProjectFolderDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectFolderDeleteResponses, unknown, ThrowOnError>({
    url: '/project-folders/{folderId}',
    ...options,
  });

/**
 * @deprecated
 */
export const projectFolderGet = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderGetData, ThrowOnError>,
): RequestResult<ProjectFolderGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectFolderGetResponses, unknown, ThrowOnError>({
    querySerializer: {
      parameters: {
        type: { array: { explode: false } },
        'drafting-mode': { array: { explode: false } },
        'review-status': { array: { explode: false } },
        assignee: { array: { explode: false } },
      },
    },
    responseType: 'json',
    url: '/project-folders/{folderId}',
    ...options,
  });

export const projectFolderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderUpdateData, ThrowOnError>,
): RequestResult<ProjectFolderUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectFolderUpdateResponses, unknown, ThrowOnError>({
    url: '/project-folders/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectFolderRemoveItems = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderRemoveItemsData, ThrowOnError>,
): RequestResult<ProjectFolderRemoveItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectFolderRemoveItemsResponses, unknown, ThrowOnError>({
    url: '/project-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectFolderAddItems = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderAddItemsData, ThrowOnError>,
): RequestResult<ProjectFolderAddItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectFolderAddItemsResponses, unknown, ThrowOnError>({
    url: '/project-folders/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectFolderQuery = <ThrowOnError extends boolean = false>(
  options: Options<ProjectFolderQueryData, ThrowOnError>,
): RequestResult<ProjectFolderQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectFolderQueryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/project-folders/{folderId}/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listTasks = <ThrowOnError extends boolean = false>(
  options: Options<ListTasksData, ThrowOnError>,
): RequestResult<ListTasksResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListTasksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/project-tasks/{resourceType}/{resourceId}',
    ...options,
  });

/**
 * @deprecated
 */
export const projectList = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectListData, ThrowOnError>,
): RequestResult<ProjectListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProjectListResponses, unknown, ThrowOnError>({
    querySerializer: {
      parameters: {
        type: { array: { explode: false } },
        'drafting-mode': { array: { explode: false } },
        'review-status': { array: { explode: false } },
        assignee: { array: { explode: false } },
      },
    },
    responseType: 'json',
    url: '/projects',
    ...options,
  });

/**
 * @deprecated
 */
export const projectAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectAnalyticsData, ThrowOnError>,
): RequestResult<ProjectAnalyticsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProjectAnalyticsResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { type: { array: { explode: false } } } },
    responseType: 'json',
    url: '/projects/analytics',
    ...options,
  });

export const projectQueryAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<ProjectQueryAnalyticsData, ThrowOnError>,
): RequestResult<ProjectQueryAnalyticsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectQueryAnalyticsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/projects/analytics/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectDeleteProjects = <ThrowOnError extends boolean = false>(
  options: Options<ProjectDeleteProjectsData, ThrowOnError>,
): RequestResult<ProjectDeleteProjectsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectDeleteProjectsResponses, unknown, ThrowOnError>({
    url: '/projects/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const projectFacets = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectFacetsData, ThrowOnError>,
): RequestResult<ProjectFacetsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProjectFacetsResponses, unknown, ThrowOnError>({
    querySerializer: {
      parameters: {
        type: { array: { explode: false } },
        'draft-mode': { array: { explode: false } },
        'review-status': { array: { explode: false } },
        assignee: { array: { explode: false } },
      },
    },
    responseType: 'json',
    url: '/projects/facets',
    ...options,
  });

export const projectQueryFacets = <ThrowOnError extends boolean = false>(
  options: Options<ProjectQueryFacetsData, ThrowOnError>,
): RequestResult<ProjectQueryFacetsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectQueryFacetsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/projects/facets/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectQuery = <ThrowOnError extends boolean = false>(
  options: Options<ProjectQueryData, ThrowOnError>,
): RequestResult<ProjectQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectQueryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/projects/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectUpdateReview = <ThrowOnError extends boolean = false>(
  options: Options<ProjectUpdateReviewData, ThrowOnError>,
): RequestResult<ProjectUpdateReviewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectUpdateReviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/projects/{resourceType}/{resourceId}/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectTrackProjectViewed = <ThrowOnError extends boolean = false>(
  options: Options<ProjectTrackProjectViewedData, ThrowOnError>,
): RequestResult<ProjectTrackProjectViewedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectTrackProjectViewedResponses, unknown, ThrowOnError>({
    url: '/projects/{resourceType}/{resourceId}/track-viewed',
    ...options,
  });

export const referenceSignGetReferenceSignsByResource = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignGetReferenceSignsByResourceData, ThrowOnError>,
): RequestResult<ReferenceSignGetReferenceSignsByResourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ReferenceSignGetReferenceSignsByResourceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}',
    ...options,
  });

export const referenceSignCreateReferenceSign = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignCreateReferenceSignData, ThrowOnError>,
): RequestResult<ReferenceSignCreateReferenceSignResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignCreateReferenceSignResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/reference-sign/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignArchiveReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignArchiveReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignArchiveReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignArchiveReferenceSignsResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignBatchCreateReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignBatchCreateReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignBatchCreateReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignBatchCreateReferenceSignsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignEditReferenceSign = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignEditReferenceSignData, ThrowOnError>,
): RequestResult<ReferenceSignEditReferenceSignResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ReferenceSignEditReferenceSignResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/edit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignBatchEditReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignBatchEditReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignBatchEditReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ReferenceSignBatchEditReferenceSignsResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/edit/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignGetReferenceSignsByFigure = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignGetReferenceSignsByFigureData, ThrowOnError>,
): RequestResult<ReferenceSignGetReferenceSignsByFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ReferenceSignGetReferenceSignsByFigureResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/figure/{figureId}',
    ...options,
  });

export const referenceSignBatchGenerateReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignBatchGenerateReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignBatchGenerateReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignBatchGenerateReferenceSignsResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/generate/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignGenerateReferenceSignsForFigure = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignGenerateReferenceSignsForFigureData, ThrowOnError>,
): RequestResult<ReferenceSignGenerateReferenceSignsForFigureResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignGenerateReferenceSignsForFigureResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/generate/figure/{figureId}',
    ...options,
  });

export const referenceSignGenerateReferenceSignsFromImage = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignGenerateReferenceSignsFromImageData, ThrowOnError>,
): RequestResult<ReferenceSignGenerateReferenceSignsFromImageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignGenerateReferenceSignsFromImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/generate/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const referenceSignImportReferenceSignsFromDocument = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignImportReferenceSignsFromDocumentData, ThrowOnError>,
): RequestResult<ReferenceSignImportReferenceSignsFromDocumentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignImportReferenceSignsFromDocumentResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/import/document',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const referenceSignLinkReferenceSign = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignLinkReferenceSignData, ThrowOnError>,
): RequestResult<ReferenceSignLinkReferenceSignResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignLinkReferenceSignResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignBatchLinkReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignBatchLinkReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignBatchLinkReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignBatchLinkReferenceSignsResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/link/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignPlaceReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignPlaceReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignPlaceReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignPlaceReferenceSignsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/place',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const referenceSignPlaceReferenceSignsV2 = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignPlaceReferenceSignsV2Data, ThrowOnError>,
): RequestResult<ReferenceSignPlaceReferenceSignsV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignPlaceReferenceSignsV2Responses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/reference-sign/{resourceType}/{resourceId}/place/v2',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const referenceSignUnlinkReferenceSign = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignUnlinkReferenceSignData, ThrowOnError>,
): RequestResult<ReferenceSignUnlinkReferenceSignResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignUnlinkReferenceSignResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/unlink',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignBatchUnlinkReferenceSigns = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignBatchUnlinkReferenceSignsData, ThrowOnError>,
): RequestResult<ReferenceSignBatchUnlinkReferenceSignsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReferenceSignBatchUnlinkReferenceSignsResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/unlink/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const referenceSignPutValue = <ThrowOnError extends boolean = false>(
  options: Options<ReferenceSignPutValueData, ThrowOnError>,
): RequestResult<ReferenceSignPutValueResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ReferenceSignPutValueResponses, unknown, ThrowOnError>({
    url: '/reference-sign/{resourceType}/{resourceId}/value',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resourceKnowledgeListForDocument = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeListForDocumentData, ThrowOnError>,
): RequestResult<ResourceKnowledgeListForDocumentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ResourceKnowledgeListForDocumentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/resource-knowledge/document/{documentId}',
    ...options,
  });

export const resourceKnowledgeAttachToDocument = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeAttachToDocumentData, ThrowOnError>,
): RequestResult<ResourceKnowledgeAttachToDocumentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ResourceKnowledgeAttachToDocumentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/resource-knowledge/document/{documentId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resourceKnowledgeDetachFromDocument = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeDetachFromDocumentData, ThrowOnError>,
): RequestResult<ResourceKnowledgeDetachFromDocumentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ResourceKnowledgeDetachFromDocumentResponses, unknown, ThrowOnError>({
    url: '/resource-knowledge/document/{documentId}/{knowledgeId}',
    ...options,
  });

export const resourceKnowledgeTemplateShareConflicts = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeTemplateShareConflictsData, ThrowOnError>,
): RequestResult<ResourceKnowledgeTemplateShareConflictsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ResourceKnowledgeTemplateShareConflictsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/resource-knowledge/template/{templateId}/share-conflicts',
    ...options,
  });

export const resourceKnowledgeResolveTemplateShareConflicts = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeResolveTemplateShareConflictsData, ThrowOnError>,
): RequestResult<ResourceKnowledgeResolveTemplateShareConflictsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ResourceKnowledgeResolveTemplateShareConflictsResponses, unknown, ThrowOnError>({
    url: '/resource-knowledge/template/{templateId}/share-conflicts/resolve',
    ...options,
  });

export const resourceKnowledgeList = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeListData, ThrowOnError>,
): RequestResult<ResourceKnowledgeListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ResourceKnowledgeListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/resource-knowledge/{resourceType}/{resourceId}',
    ...options,
  });

export const resourceKnowledgeAttach = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeAttachData, ThrowOnError>,
): RequestResult<ResourceKnowledgeAttachResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ResourceKnowledgeAttachResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/resource-knowledge/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resourceKnowledgeDetach = <ThrowOnError extends boolean = false>(
  options: Options<ResourceKnowledgeDetachData, ThrowOnError>,
): RequestResult<ResourceKnowledgeDetachResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ResourceKnowledgeDetachResponses, unknown, ThrowOnError>({
    url: '/resource-knowledge/{resourceType}/{resourceId}/{knowledgeId}',
    ...options,
  });

export const sequencesDeleteBatch = <ThrowOnError extends boolean = false>(
  options: Options<SequencesDeleteBatchData, ThrowOnError>,
): RequestResult<SequencesDeleteBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<SequencesDeleteBatchResponses, unknown, ThrowOnError>({
    url: '/sequence/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const sequencesBulkRenumber = <ThrowOnError extends boolean = false>(
  options: Options<SequencesBulkRenumberData, ThrowOnError>,
): RequestResult<SequencesBulkRenumberResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SequencesBulkRenumberResponses, unknown, ThrowOnError>({
    url: '/sequence/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const sequenceMolTypesList = <ThrowOnError extends boolean = false>(
  options?: Options<SequenceMolTypesListData, ThrowOnError>,
): RequestResult<SequenceMolTypesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SequenceMolTypesListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sequence/mol-types',
    ...options,
  });

export const sequencesList = <ThrowOnError extends boolean = false>(
  options: Options<SequencesListData, ThrowOnError>,
): RequestResult<SequencesListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SequencesListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sequence/{resourceType}/{resourceId}',
    ...options,
  });

export const sequencesDeleteAll = <ThrowOnError extends boolean = false>(
  options: Options<SequencesDeleteAllData, ThrowOnError>,
): RequestResult<SequencesDeleteAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<SequencesDeleteAllResponses, unknown, ThrowOnError>({
    url: '/sequence/{resourceType}/{resourceId}/all',
    ...options,
  });

export const sequencesBatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesBatchCreateData, ThrowOnError>,
): RequestResult<SequencesBatchCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SequencesBatchCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sequence/{resourceType}/{resourceId}/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const sequencesExport = <ThrowOnError extends boolean = false>(
  options: Options<SequencesExportData, ThrowOnError>,
): RequestResult<SequencesExportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SequencesExportResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/sequence/{resourceType}/{resourceId}/export',
    ...options,
  });

export const sequencesExtractFromTabularFile = <ThrowOnError extends boolean = false>(
  options: Options<SequencesExtractFromTabularFileData, ThrowOnError>,
): RequestResult<SequencesExtractFromTabularFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SequencesExtractFromTabularFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/sequence/{resourceType}/{resourceId}/extract-from-tabular-file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const sequencesImportSequences = <ThrowOnError extends boolean = false>(
  options: Options<SequencesImportSequencesData, ThrowOnError>,
): RequestResult<SequencesImportSequencesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SequencesImportSequencesResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/sequence/{resourceType}/{resourceId}/import',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const sequencesParseModifications = <ThrowOnError extends boolean = false>(
  options: Options<SequencesParseModificationsData, ThrowOnError>,
): RequestResult<SequencesParseModificationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SequencesParseModificationsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/sequence/{resourceType}/{resourceId}/parse-modifications',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const sequencesGet = <ThrowOnError extends boolean = false>(
  options: Options<SequencesGetData, ThrowOnError>,
): RequestResult<SequencesGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SequencesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sequence/{sequenceId}',
    ...options,
  });

export const sequencesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesUpdateData, ThrowOnError>,
): RequestResult<SequencesUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SequencesUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sequence/{sequenceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Every setting resolved for the calling user.
 */
export const getResolvedSettings = <ThrowOnError extends boolean = false>(
  options?: Options<GetResolvedSettingsData, ThrowOnError>,
): RequestResult<GetResolvedSettingsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetResolvedSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/settings',
    ...options,
  });

export const generateSigmaSearchQuery = <ThrowOnError extends boolean = false>(
  options: Options<GenerateSigmaSearchQueryData, ThrowOnError>,
): RequestResult<GenerateSigmaSearchQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<GenerateSigmaSearchQueryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/query/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const createSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<CreateSigmaSearchData, ThrowOnError>,
): RequestResult<CreateSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CreateSigmaSearchResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/{resourceType}/{resourceId}/search/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listSigmaSearches = <ThrowOnError extends boolean = false>(
  options: Options<ListSigmaSearchesData, ThrowOnError>,
): RequestResult<ListSigmaSearchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListSigmaSearchesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/{resourceType}/{resourceId}/searches',
    ...options,
  });

export const deleteSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSigmaSearchData, ThrowOnError>,
): RequestResult<DeleteSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteSigmaSearchResponses, unknown, ThrowOnError>({
    url: '/sigma-search/{searchId}',
    ...options,
  });

export const getSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetSigmaSearchData, ThrowOnError>,
): RequestResult<GetSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetSigmaSearchResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/{searchId}',
    ...options,
  });

export const updateSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSigmaSearchData, ThrowOnError>,
): RequestResult<UpdateSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateSigmaSearchResponses, unknown, ThrowOnError>({
    url: '/sigma-search/{searchId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const calibrateSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<CalibrateSigmaSearchData, ThrowOnError>,
): RequestResult<CalibrateSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CalibrateSigmaSearchResponses, unknown, ThrowOnError>({
    url: '/sigma-search/{searchId}/calibrate',
    ...options,
  });

export const getSigmaSearchQuery = <ThrowOnError extends boolean = false>(
  options: Options<GetSigmaSearchQueryData, ThrowOnError>,
): RequestResult<GetSigmaSearchQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetSigmaSearchQueryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/{searchId}/query',
    ...options,
  });

export const putSigmaSearchQuery = <ThrowOnError extends boolean = false>(
  options: Options<PutSigmaSearchQueryData, ThrowOnError>,
): RequestResult<PutSigmaSearchQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutSigmaSearchQueryResponses, unknown, ThrowOnError>({
    url: '/sigma-search/{searchId}/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const runSigmaSearch = <ThrowOnError extends boolean = false>(
  options: Options<RunSigmaSearchData, ThrowOnError>,
): RequestResult<RunSigmaSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<RunSigmaSearchResponses, unknown, ThrowOnError>({
    url: '/sigma-search/{searchId}/run',
    ...options,
  });

export const getSigmaSearchStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetSigmaSearchStatusData, ThrowOnError>,
): RequestResult<GetSigmaSearchStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetSigmaSearchStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/sigma-search/{searchId}/status',
    ...options,
  });

export const captureSuggestionReviews = <ThrowOnError extends boolean = false>(
  options: Options<CaptureSuggestionReviewsData, ThrowOnError>,
): RequestResult<CaptureSuggestionReviewsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CaptureSuggestionReviewsResponses, unknown, ThrowOnError>({
    url: '/telemetry/{resourceType}/{resourceId}/suggestions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ListTemplatesData, ThrowOnError>,
): RequestResult<ListTemplatesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ListTemplatesResponses, unknown, ThrowOnError>({
    querySerializer: {
      parameters: { 'template-type': { array: { explode: false } }, language: { array: { explode: false } } },
    },
    responseType: 'json',
    url: '/templates',
    ...options,
  });

export const saveFormTemplate = <ThrowOnError extends boolean = false>(
  options: Options<SaveFormTemplateData, ThrowOnError>,
): RequestResult<SaveFormTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveFormTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/templates/form',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const saveTableTemplate = <ThrowOnError extends boolean = false>(
  options: Options<SaveTableTemplateData, ThrowOnError>,
): RequestResult<SaveTableTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaveTableTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/templates/table',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteTemplate = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTemplateData, ThrowOnError>,
): RequestResult<DeleteTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DeleteTemplateResponses, unknown, ThrowOnError>({
    url: '/templates/{templateId}',
    ...options,
  });

export const getTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateData, ThrowOnError>,
): RequestResult<GetTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/templates/{templateId}',
    ...options,
  });

export const updateTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTemplateData, ThrowOnError>,
): RequestResult<UpdateTemplateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UpdateTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/templates/{templateId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const temporaryFileUploadTemporaryFile = <ThrowOnError extends boolean = false>(
  options: Options<TemporaryFileUploadTemporaryFileData, ThrowOnError>,
): RequestResult<TemporaryFileUploadTemporaryFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TemporaryFileUploadTemporaryFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/temporary-file/{resourceType}/{resourceId}/upload/{fileType}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const temporaryFileGetTemporaryFile = <ThrowOnError extends boolean = false>(
  options: Options<TemporaryFileGetTemporaryFileData, ThrowOnError>,
): RequestResult<TemporaryFileGetTemporaryFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TemporaryFileGetTemporaryFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/temporary-file/{temporaryFileId}',
    ...options,
  });

/**
 * Names the people given by id, so a client holding only ids (from a link, say) can show who they are. Every id
 * must belong to the caller's organisation; ids that match nobody are left out, and disabled users are included.
 */
export const userLookup = <ThrowOnError extends boolean = false>(
  options: Options<UserLookupData, ThrowOnError>,
): RequestResult<UserLookupResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UserLookupResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/users/lookup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderOperationsDelete = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderOperationsDeleteData, ThrowOnError>,
): RequestResult<ItemFolderOperationsDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ItemFolderOperationsDeleteResponses, unknown, ThrowOnError>({
    url: '/{folderId}',
    ...options,
  });

export const itemFolderOperationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderOperationsUpdateData, ThrowOnError>,
): RequestResult<ItemFolderOperationsUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ItemFolderOperationsUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderOperationsAddItems = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderOperationsAddItemsData, ThrowOnError>,
): RequestResult<ItemFolderOperationsAddItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ItemFolderOperationsAddItemsResponses, unknown, ThrowOnError>({
    url: '/{folderId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const itemFolderOperationsGetAll = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderOperationsGetAllData, ThrowOnError>,
): RequestResult<ItemFolderOperationsGetAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ItemFolderOperationsGetAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/{resourceType}/{resourceId}',
    ...options,
  });

export const itemFolderOperationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ItemFolderOperationsCreateData, ThrowOnError>,
): RequestResult<ItemFolderOperationsCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ItemFolderOperationsCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/{resourceType}/{resourceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
